/* eslint-disable */
// Generated from the approved onboarding source packages.
// Legacy static route fields are intentionally omitted; runtime routes come only from the backend API.
// Do not edit task ids, order, steps, before actions or text manually.

export const onboardingArchiveEditions = {
  "1": {
  "edition": "sample-library",
  "editionName": "样本库运营版",
  "guideVersion": "sample-library-2.2.0",
  "groups": [
    {
      "id": "essential",
      "label": "上手必学",
      "description": "先理解界面和业务主线，再进入岗位任务。"
    },
    {
      "id": "role",
      "label": "岗位任务",
      "description": "按客户、项目、财务和辅助工具学习。"
    },
    {
      "id": "station",
      "label": "会员运营",
      "description": "仅在样本库运营版显示会员、站点和样本运营能力。"
    },
    {
      "id": "admin",
      "label": "管理员任务",
      "description": "仅向具备相应菜单和权限的管理员显示。"
    }
  ],
  "goalOptions": [
    {
      "id": "project",
      "label": "创建项目并完成交付",
      "hint": "学习客户、项目交付与财务主线。"
    },
    {
      "id": "customer",
      "label": "管理客户与业务规则",
      "hint": "适合客户运营岗位。"
    },
    {
      "id": "quality",
      "label": "复盘项目与质量",
      "hint": "适合质控和项目复盘。"
    },
    {
      "id": "finance",
      "label": "理解财务与结算",
      "hint": "适合财务和业务负责人。"
    },
    {
      "id": "admin",
      "label": "配置团队与系统",
      "hint": "适合系统管理员。"
    },
    {
      "id": "station",
      "label": "运营会员与样本库",
      "hint": "学习会员、分组、等级、站点规则和会员数据。"
    }
  ],
  "experienceOptions": [
    {
      "id": "new",
      "label": "第一次使用此类系统",
      "hint": "保留当前版本全部安全教学步骤。",
      "recommended": true
    },
    {
      "id": "similar",
      "label": "用过类似调查平台",
      "hint": "保留每项任务的主要入口和风险说明。"
    },
    {
      "id": "expert",
      "label": "已经熟悉业务流程",
      "hint": "只看关键入口和最后的风险检查。"
    }
  ],
  "taskOrder": [
    "interface-tour",
    "customer-management",
    "cooperation-resources",
    "project-create",
    "finance-overview",
    "station-overview",
    "station-members",
    "auxiliary-tools",
    "organization-permissions",
    "system-config"
  ],
  "tasks": [
    {
      "id": "interface-tour",
      "group": "essential",
      "title": "60 秒业务地图",
      "description": "认识业务导航、模块侧栏、全局搜索、个人入口与快捷入口。",
      "estimate": "约 60 秒",
      "goals": [
        "project",
        "customer",
        "quality",
        "finance",
        "admin",
        "station"
      ],
      "steps": [
        {
          "id": "top-nav",
          "target": "[data-guide-id=\"top-nav\"]",
          "title": "先认清业务主线",
          "text": "客户与合作资源确定项目来源；项目依次经过创建、会员或会员组调度、参与与终止记录核对、会员账单及客户发票。组织与配置提供权限和默认规则。"
        },
        {
          "id": "side-nav",
          "target": "[data-guide-id=\"side-nav\"]",
          "title": "当前模块的侧边导航",
          "text": "侧边栏只展示当前业务模块内的页面。进入项目、财务、会员或配置后，可先通过高亮菜单确认当前位置，再按业务顺序继续操作。"
        },
        {
          "id": "global-search",
          "target": "[data-guide-id=\"global-search\"]",
          "title": "全局搜索",
          "text": "不确定功能在哪里时，可以按功能、帮助或数据关键字查找。搜索不会修改业务数据。",
          "interaction": "simulate"
        },
        {
          "id": "personal-menu",
          "target": "[data-guide-id=\"personal-menu\"]",
          "title": "个人中心与教程入口",
          "text": "这里可以进入个人设置、更新日志、新手引导与教程和安全退出。关闭右下角入口后，也能从这里重新打开。"
        },
        {
          "id": "quick-actions",
          "target": "[data-guide-id=\"quick-actions\"]",
          "title": "四个快捷入口",
          "text": "这些入口用于快速进入新增、客户、会员和合作资源相关页面，是导航捷径，不会替代正式配置流程。"
        }
      ]
    },
    {
      "id": "customer-management",
      "group": "role",
      "title": "建立客户档案与项目规则",
      "description": "按主体、结算、风控、回调和开票顺序准备项目来源。",
      "estimate": "约 3 分钟",
      "permission": "partner.view",
      "goals": [
        "customer"
      ],
      "steps": [
        {
          "id": "customer-table",
          "target": "[data-guide-id=\"customer-table\"]",
          "title": "客户档案是项目规则来源",
          "text": "客户状态、账期、分配方式和 API 类型会影响其项目。编辑、删除或停用前先检查关联项目、账单与发票。",
          "readOnly": true
        },
        {
          "id": "customer-new",
          "target": "[data-guide-id=\"customer-new\"]",
          "title": "新增前先准备合同信息",
          "text": "先准备主体、业务联系人、币种、账期、付款规则、回调和发票资料。教程只打开配置入口，不会创建客户。",
          "before": {
            "close": [
              "[data-guide-id=\"customer-analysis\"]"
            ],
            "waitFor": "[data-guide-id=\"customer-new\"]"
          }
        },
        {
          "id": "customer-identity",
          "target": "[data-guide-id=\"customer-base-identity\"]",
          "title": "主体与联系人必须可追溯",
          "text": "名称和公司用于业务识别，联系人、手机和邮箱用于协作通知。应使用正式业务资料，不要录入临时测试或个人敏感信息。",
          "before": {
            "click": "[data-guide-id=\"customer-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"customer-drawer\"]",
            "tab": "[data-guide-id=\"customer-tab-base\"]",
            "snapshot": "[data-guide-id=\"customer-drawer\"]",
            "close": []
          }
        },
        {
          "id": "customer-settlement",
          "target": "[data-guide-id=\"customer-base-settlement\"]",
          "title": "结算规则必须与合同一致",
          "text": "币种、账期和付款规则会影响项目报价、对账和发票。未与合同确认时不要保存。",
          "before": {
            "click": "[data-guide-id=\"customer-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"customer-drawer\"]",
            "tab": "[data-guide-id=\"customer-tab-base\"]",
            "snapshot": "[data-guide-id=\"customer-drawer\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "customer-risk",
          "target": "[data-guide-id=\"customer-risk-panel\"]",
          "title": "分配、风控与安检会向项目传递",
          "text": "部门分配、客户级风险和第三方安检会影响关联项目。修改前核对继承范围、检测产品和例外，避免正常流量被拦截。",
          "before": {
            "click": "[data-guide-id=\"customer-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"customer-drawer\"]",
            "tab": "[data-guide-id=\"customer-tab-risk\"]",
            "snapshot": "[data-guide-id=\"customer-drawer\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "customer-callback-s2s",
          "target": "[data-guide-id=\"customer-callback-s2s\"]",
          "title": "同时核对前端跳转与 S2S 回调",
          "text": "完成、配额满、筛除和安全终止既可能触发前端重定向，也可能触发服务器回调。上线前用测试项目核对 URL、UID 与状态映射；教程不发送请求。",
          "before": {
            "click": "[data-guide-id=\"customer-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"customer-drawer\"]",
            "tab": "[data-guide-id=\"customer-tab-callback\"]",
            "snapshot": "[data-guide-id=\"customer-drawer\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "customer-invoice",
          "target": "[data-guide-id=\"customer-invoice-panel\"]",
          "title": "建档完成不等于可以开票",
          "text": "发票模板应与合同主体、税务信息和币种一致。当前客户没有保存；真实顺序是建档复核、创建项目、形成结算，再由有权限人员开票。",
          "before": {
            "click": "[data-guide-id=\"customer-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"customer-drawer\"]",
            "tab": "[data-guide-id=\"customer-tab-invoice\"]",
            "snapshot": "[data-guide-id=\"customer-drawer\"]",
            "close": []
          },
          "readOnly": true
        }
      ]
    },
    {
      "id": "cooperation-resources",
      "group": "role",
      "title": "管理合作资源",
      "description": "从对外资料和云客户筛选开始，建立合作关系并追踪积分与账单。",
      "estimate": "约 4 分钟",
      "permission": "partner.view",
      "goals": [
        "customer",
        "project"
      ],
      "steps": [
        {
          "id": "cooperation-overview",
          "target": ".coop-my-overview",
          "title": "先理解合作资源闭环",
          "text": "正确顺序是：完善对外资料 → 在云资源中筛选对象并核对详情 → 发起或处理合作申请 → 申请通过后维护合作关系 → 在积分和账单中追踪资源消耗。教程只讲解流程，不会自动申请、接受、拒绝、解锁或付款。",
          "readOnly": true
        },
        {
          "id": "cooperation-profile",
          "target": "[data-my-panel=\"profile\"]",
          "title": "先完善对外资料与开放范围",
          "text": "名称、简介、业务区域、联系信息和公开能力决定合作方看到的企业身份；云资源开放范围决定可发现的合作对象。请先核对真实性和可公开性，再由有权限人员保存，教程不会提交资料或切换开放状态。",
          "before": {
            "click": "[data-my-tab=\"profile\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-my-panel=\"profile\"]:not([hidden])",
            "snapshot": "[data-my-panel=\"profile\"]"
          },
          "readOnly": true
        },
        {
          "id": "cooperation-customer-market",
          "target": ".coop-market-card",
          "title": "筛选云客户合作机会",
          "text": "先按地区、行业、评分和合作状态筛选，再比较项目发布、结算表现、响应速度和合作评价。高需求量不等于低风险，仍需确认需求真实性、结算条件与交付边界。",
          "before": {
            "close": [
              "[data-coop-detail-layer]"
            ],
            "waitFor": ".coop-market-card"
          },
          "interaction": "simulate",
          "readOnly": true
        },
        {
          "id": "cooperation-customer-detail",
          "target": ".coop-detail-drawer",
          "title": "核对客户详情与合作条件",
          "text": "重点核对企业资料、项目机会、结算表现、评价和公开联系方式。解锁、发送消息或申请合作前，应确认负责人、合同主体和回款条件；教程只展示详情，不会提交任何申请。",
          "before": {
            "click": "[data-coop-detail]",
            "safeAction": "open-surface",
            "waitFor": "[data-coop-detail-layer][aria-hidden=\"false\"] .coop-detail-drawer",
            "snapshot": ".coop-detail-drawer"
          },
          "readOnly": true
        },
        {
          "id": "cooperation-applications",
          "target": "[data-my-panel=\"sent\"]",
          "title": "按方向和状态处理合作申请",
          "text": "收到的申请用于判断是否接受外部合作，发出的申请用于追踪对方处理结果。先核对申请方、合作目的、负责人和当前状态；接受、拒绝、撤回或再次申请都必须由用户主动确认。",
          "before": {
            "click": "[data-my-tab=\"sent\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-my-panel=\"sent\"]:not([hidden])",
            "snapshot": "[data-my-panel=\"sent\"]"
          },
          "readOnly": true
        },
        {
          "id": "cooperation-partners",
          "target": "[data-my-panel=\"partners\"]",
          "title": "申请通过后才进入合作关系",
          "text": "只有通过的合作申请才会形成正式合作关系。这里用于核对合作对象、合作状态和后续沟通入口；暂停或解除关系前，应先确认正在执行的项目、账务和双方负责人。",
          "before": {
            "click": "[data-my-tab=\"partners\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-my-panel=\"partners\"]:not([hidden])",
            "snapshot": "[data-my-panel=\"partners\"]"
          },
          "readOnly": true
        },
        {
          "id": "cooperation-points",
          "target": "[data-my-panel=\"points\"]",
          "title": "用积分明细追踪资源消耗",
          "text": "积分通常与资料解锁、合作触达等资源动作相关。按时间、业务类型和变动方向核对来源，出现异常时先回查对应合作对象和操作记录；教程不会消耗或调整积分。",
          "before": {
            "click": "[data-my-tab=\"points\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-my-panel=\"points\"]:not([hidden])",
            "snapshot": "[data-my-panel=\"points\"]"
          },
          "readOnly": true
        },
        {
          "id": "cooperation-bills",
          "target": "[data-my-panel=\"bills\"]",
          "title": "最后核对合作账单",
          "text": "按账单周期、合作对象、币种、金额和状态核对费用，并与积分明细、合同及实际合作动作保持一致。支付、确认或争议处理会影响真实账务，必须由有权限人员复核，教程不会代为操作。",
          "before": {
            "click": "[data-my-tab=\"bills\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-my-panel=\"bills\"]:not([hidden])",
            "snapshot": "[data-my-panel=\"bills\"]"
          },
          "readOnly": true
        }
      ]
    },
    {
      "id": "project-create",
      "group": "role",
      "title": "创建项目与发布前检查",
      "description": "按归属、商业参数、入口、配额和风控完成发布前核对。",
      "estimate": "约 3 分钟",
      "permission": "project.view",
      "goals": [
        "project"
      ],
      "steps": [
        {
          "id": "project-table",
          "target": "[data-guide-id=\"project-table\"]",
          "title": "先区分草稿、运行与结束状态",
          "text": "上架、下架、分配和删除会改变真实业务。操作前核对项目主体、客户、价格、目标量和当前状态，教程不会点击行操作。",
          "readOnly": true
        },
        {
          "id": "project-new",
          "target": "[data-guide-id=\"project-new\"]",
          "title": "资料齐全后再创建",
          "text": "先准备客户归属、国家、币种、CPI、LOI、IR、项目 URL、配额与风险规则。教程只介绍入口，不会新增或保存项目。"
        },
        {
          "id": "project-identity",
          "target": "[data-guide-id=\"project-base-identity\"]",
          "title": "项目归属决定后续对账",
          "text": "项目代码用于追踪，客户决定需求与结算来源，国家和币种决定交付口径。三者应与合同和外部问卷一致。",
          "before": {
            "click": "[data-guide-id=\"project-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"project-drawer\"]",
            "tab": "[data-guide-id=\"project-tab-base\"]",
            "snapshot": "[data-guide-id=\"project-drawer\"]",
            "close": []
          }
        },
        {
          "id": "project-commercial",
          "target": "[data-guide-id=\"project-base-commercial\"]",
          "title": "确认价格与会员分配边界",
          "text": "核对 CPI、付款规则以及会员或会员组分配方式。B2B/B2C、激活、置顶和路由检查会影响流量；教程不会切换。",
          "before": {
            "click": "[data-guide-id=\"project-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"project-drawer\"]",
            "tab": "[data-guide-id=\"project-tab-base\"]",
            "snapshot": "[data-guide-id=\"project-drawer\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "project-metrics",
          "target": "[data-guide-id=\"project-base-metrics\"]",
          "title": "入口参数与交付指标要一致",
          "text": "LOI、IR、目标量和项目 URL 共同决定交付预期；URL 中的 UID 占位符必须保留。附件只上传必要资料，上线前应完成测试跳转。",
          "before": {
            "click": "[data-guide-id=\"project-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"project-drawer\"]",
            "tab": "[data-guide-id=\"project-tab-base\"]",
            "snapshot": "[data-guide-id=\"project-drawer\"]",
            "close": []
          },
          "risk": "external-link"
        },
        {
          "id": "project-quota-device",
          "target": "[data-guide-id=\"project-quota-device\"]",
          "title": "把准入、配额、互斥和筛选一起核对",
          "text": "设备准入、总配额、分设备配额、项目互斥和前置筛选必须互相一致；任一处冲突都可能造成误拦截或无可用配额。",
          "before": {
            "click": "[data-guide-id=\"project-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"project-drawer\"]",
            "tab": "[data-guide-id=\"project-tab-quota\"]",
            "snapshot": "[data-guide-id=\"project-drawer\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "project-risk-security",
          "target": "[data-guide-id=\"project-risk-security\"]",
          "title": "完成风控检查仍不等于已发布",
          "text": "内部检测、小时限流、IP/设备和第三方安检会叠加影响参与。先与客户级规则核对，再保存草稿、测试 URL 与回调，最后由有权限人员发布；教程不会提交。",
          "before": {
            "click": "[data-guide-id=\"project-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"project-drawer\"]",
            "tab": "[data-guide-id=\"project-tab-risk\"]",
            "snapshot": "[data-guide-id=\"project-drawer\"]",
            "close": []
          },
          "readOnly": true
        }
      ]
    },
    {
      "id": "finance-overview",
      "group": "role",
      "title": "会员、员工与客户财务链路",
      "description": "从财务日志追溯变动，再生成账单和客户发票。",
      "estimate": "约 3 分钟",
      "permission": "finance.view",
      "goals": [
        "finance"
      ],
      "steps": [
        {
          "id": "finance-log-table",
          "target": ".member-finance-table-card",
          "title": "会员财务日志是变动依据",
          "text": "先按项目、会员、类型和时间核对收入、支出及余额变化。日志用于解释账单来源，不应直接凭当前余额判断结算。"
        },
        {
          "id": "finance-employee-log",
          "target": ".dashboard-page",
          "title": "员工财务日志独立核对",
          "text": "员工提成或调整应先在员工财务日志确认来源、对象和时间，再进入员工账单。教程不会新增或修改流水。",
          "readOnly": true
        },
        {
          "id": "finance-bill-table",
          "target": ".finance-bill-table-card",
          "title": "会员账单汇总可结算明细",
          "text": "账单把已确认的会员财务明细按周期汇总。创建前核对币种、金额、状态与异常记录，避免重复结算。",
          "readOnly": true
        },
        {
          "id": "finance-bill-risk",
          "target": ".finance-bill-toolbar",
          "title": "创建、审核与支付必须分权复核",
          "text": "新增、批量审核、拒绝、支付和删除都会改变真实财务状态。先核对明细、周期和审批人；教程只讲解，不执行。",
          "readOnly": true
        },
        {
          "id": "finance-employee-bill",
          "target": ".dashboard-page",
          "title": "员工账单承接已确认的员工流水",
          "text": "先核对提成规则与员工财务日志，再生成、审核或支付员工账单；不要把员工账单与外部合作方账单混用。",
          "readOnly": true
        },
        {
          "id": "finance-invoice-table",
          "target": "[data-guide-id=\"finance-customer-invoice-table\"]",
          "title": "客户发票建立在已确认结算之上",
          "text": "先完成项目结算并核对会员与员工成本，再按客户、币种、金额和合同主体准备发票。",
          "readOnly": true
        },
        {
          "id": "finance-invoice-risk",
          "target": "[data-guide-id=\"finance-customer-invoice-risk-actions\"]",
          "title": "开票、作废与删除都要二次确认",
          "text": "开票、批量处理、作废和删除会影响真实财务与税务记录。操作前核对审批状态和合同主体；教程不会点击。",
          "readOnly": true
        }
      ]
    },
    {
      "id": "station-overview",
      "group": "station",
      "title": "用会员看板判断运营健康度",
      "description": "统一口径后结合参与、完成、收入、审核、通过率和拒绝率。",
      "estimate": "约 2 分钟",
      "permission": "survey_station.view",
      "goals": [
        "station",
        "quality"
      ],
      "steps": [
        {
          "id": "station-analysis-kpis",
          "target": "[data-guide-id=\"station-analysis-kpis\"]",
          "title": "会员核心指标",
          "text": "结合参与、完成、收入、审核、拒绝和通过率判断运营健康度，不要只看单一指标。",
          "readOnly": true
        },
        {
          "id": "station-analysis-charts",
          "target": "[data-guide-id=\"station-analysis-charts\"]",
          "title": "趋势与结构",
          "text": "趋势和类型分布用于发现异常时段与结构变化，结论应结合记录明细复核。",
          "readOnly": true
        },
        {
          "id": "station-analysis-table",
          "target": "[data-guide-id=\"station-analysis-table\"]",
          "title": "会员指标排行",
          "text": "排行用于定位需要进一步分析的会员，不应直接作为处罚或结算依据。",
          "readOnly": true
        }
      ]
    },
    {
      "id": "station-members",
      "group": "station",
      "title": "先配置等级与会员组，再建会员",
      "description": "按等级定价、会员组归属、会员资料和运营范围完成配置。",
      "estimate": "约 3 分钟",
      "permission": "survey_station.member.view",
      "goals": [
        "station"
      ],
      "steps": [
        {
          "id": "station-level-table",
          "target": "[data-guide-id=\"station-member-levels-table\"]",
          "title": "先确认会员等级与价格比例",
          "text": "等级承载 B2B/B2C 价格比例，调整会影响关联会员结算。新增或修改前先确认运营规则，教程不保存。",
          "readOnly": true
        },
        {
          "id": "station-group-table",
          "target": "[data-guide-id=\"station-member-groups-table\"]",
          "title": "再建立会员组",
          "text": "会员组用于批量组织会员和分配项目。先确认组名、负责人和状态，避免同一会员被错误归组。",
          "readOnly": true
        },
        {
          "id": "station-member-new",
          "target": "[data-guide-id=\"station-members-new\"]",
          "title": "规则准备好后再建会员",
          "text": "先准备账号、联系方式、地区、等级和会员组。教程只打开入口，不会创建账号或发送密码。"
        },
        {
          "id": "station-member-drawer",
          "target": "[data-guide-id=\"station-members-drawer\"]",
          "title": "会员资料与验证方式要一致",
          "text": "账号、联系方式和地区应与注册验证链路一致；密码和个人信息不得进入教程日志。",
          "before": {
            "click": "[data-guide-id=\"station-members-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"station-members-drawer\"]",
            "tab": "",
            "snapshot": "[data-guide-id=\"station-members-drawer\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "station-member-assignment",
          "target": "[data-guide-id=\"station-members-control\"]",
          "title": "等级、会员组和开放范围共同生效",
          "text": "三者共同决定会员的价格、可接项目与运营路径。保存前逐项复核；教程不会提交。",
          "before": {
            "click": "[data-guide-id=\"station-members-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"station-members-drawer\"]",
            "tab": "",
            "snapshot": "[data-guide-id=\"station-members-drawer\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "station-member-table",
          "target": "[data-guide-id=\"station-members-table\"]",
          "title": "状态变化会影响登录与接单",
          "text": "列表用于核对等级、会员组、钱包、地区和 B2B/B2C 状态。编辑、停用或删除前先检查参与记录与账单。",
          "readOnly": true
        }
      ]
    },
    {
      "id": "auxiliary-tools",
      "group": "role",
      "title": "用辅助工具排查异常",
      "description": "只保留会影响业务判断的数据字典、UID、IP 和链路工具。",
      "estimate": "约 3 分钟",
      "goals": [
        "quality",
        "admin"
      ],
      "steps": [
        {
          "id": "auxiliary-dictionary",
          "target": ".dashboard-page",
          "title": "先核对公共数据字典",
          "text": "字典值可能被项目、回调或报表共同引用；新增、修改或删除前先确认使用范围，教程不会保存。",
          "readOnly": true
        },
        {
          "id": "auxiliary-uid-parse",
          "target": ".dashboard-page",
          "title": "UID 解析与分拣",
          "text": "先确认来源格式和数据权限，再解析或分拣 UID；结果用于定位记录，不会替代原始参与记录。",
          "readOnly": true
        },
        {
          "id": "auxiliary-link-parse",
          "target": ".dashboard-page",
          "title": "用链路解析定位跳转异常",
          "text": "核对项目 URL、UID 占位符、回调状态和最终地址；不要在工具中粘贴无关敏感参数。",
          "readOnly": true
        }
      ]
    },
    {
      "id": "organization-permissions",
      "group": "admin",
      "title": "配置团队与权限",
      "description": "按部门层级、角色权限、员工授权和提成规则的正确顺序完成团队配置。",
      "estimate": "约 9 分钟",
      "permission": "admin.view",
      "permissionFallback": "[href*='organization-'], [data-nav='组织']",
      "goals": [
        "admin"
      ],
      "steps": [
        {
          "id": "org-department-filters",
          "target": "[data-guide-id=\"organization-department-filters\"]",
          "title": "先按“部门 → 角色 → 员工”配置",
          "text": "部门确定组织归属和管理边界，角色复用菜单、操作与数据权限，员工最后绑定部门和角色。先检查已有部门，避免重复建档或把员工挂到错误层级。",
          "readOnly": true
        },
        {
          "id": "org-department-table",
          "target": "[data-guide-id=\"organization-department-table\"]",
          "title": "先从层级、主管和人数判断影响范围",
          "text": "重点核对上级部门、主管、员工数和状态。调整上级关系会改变组织层级；删除或停用前必须先确认下级部门、在岗员工和业务负责人。",
          "readOnly": true
        },
        {
          "id": "org-department-drawer",
          "target": "[data-guide-id=\"organization-department-drawer\"]",
          "title": "部门基本信息决定归属关系",
          "text": "新增时先填写稳定、可识别的部门名称，再选择正确的上级部门。层级选错会影响员工归属、主管管理范围和后续权限排查；教程只打开抽屉，不保存。",
          "before": {
            "click": "[data-guide-id=\"organization-department-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"organization-department-drawer\"]",
            "tab": "",
            "snapshot": "[data-guide-id=\"organization-department-drawer\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "org-department-permission",
          "target": "[data-guide-id=\"organization-department-permissions\"]",
          "title": "部门权限只授予团队必需能力",
          "text": "部门权限用于限定该组织单元的基础业务边界，不等同于员工最终权限。先按部门职责选择最小范围，再由角色补充岗位所需菜单和操作能力。",
          "before": {
            "click": "[data-guide-id=\"organization-department-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"organization-department-drawer\"]",
            "tab": "",
            "snapshot": "[data-guide-id=\"organization-department-drawer\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "org-department-manager",
          "target": "[data-guide-id=\"organization-department-managers\"]",
          "title": "主管承担管理职责，不代替角色授权",
          "text": "主管用于明确部门负责人和管理责任，但成为主管不代表自动拥有全部菜单、操作或数据权限。保存前分别核对主管人选、角色和数据范围。",
          "before": {
            "click": "[data-guide-id=\"organization-department-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"organization-department-drawer\"]",
            "tab": "",
            "snapshot": "[data-guide-id=\"organization-department-drawer\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "org-role-table",
          "target": "[data-guide-id=\"organization-role-table\"]",
          "title": "角色代表岗位职责，不代表组织归属",
          "text": "部门回答“员工属于哪里”，角色回答“员工能做什么”。先复用职责相同的现有角色，避免创建名称不同但权限重复的角色；本步骤不编辑或删除。",
          "readOnly": true
        },
        {
          "id": "org-role-dialog",
          "target": "[data-guide-id=\"organization-role-new-dialog\"]",
          "title": "按岗位职责命名角色",
          "text": "角色名称应能直接反映岗位职责，例如项目运营、财务审核或质量管理员。不要用员工姓名命名长期角色；教程只打开弹窗，不创建角色。",
          "before": {
            "click": "[data-guide-id=\"organization-role-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"organization-role-new-dialog\"]",
            "tab": "",
            "snapshot": "[data-guide-id=\"organization-role-new-dialog\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "org-role-menu",
          "target": "[data-guide-id=\"organization-role-menu-panel\"]",
          "title": "菜单权限决定能否进入页面",
          "text": "先为岗位保留完成工作必需的页面入口。菜单未授权时员工看不到页面；只授权菜单但没有操作权限时，员工可能能进入页面却无法执行按钮操作。",
          "before": {
            "close": [
              "[data-guide-id=\"organization-role-new-dialog\"]"
            ],
            "click": "[data-role-table-body] [data-role-menu]:not([disabled])",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"organization-role-menu-drawer\"]",
            "snapshot": "[data-guide-id=\"organization-role-menu-drawer\"]"
          },
          "readOnly": true
        },
        {
          "id": "org-role-permissions",
          "target": "[data-guide-id=\"organization-role-permission-panel\"]",
          "title": "操作权限与数据范围必须分别核对",
          "text": "操作权限决定可新增、编辑、审核、删除或导出什么；数据权限决定能看到哪些客户、会员、项目或团队数据。两者缺一都可能造成工作受阻或越权。",
          "before": {
            "close": [
              "[data-guide-id=\"organization-role-menu-drawer\"]"
            ],
            "click": "[data-role-table-body] [data-role-permission]:not([disabled])",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"organization-role-permission-drawer\"]",
            "snapshot": "[data-guide-id=\"organization-role-permission-drawer\"]"
          },
          "readOnly": true
        },
        {
          "id": "org-role-diagnostics",
          "target": "[data-guide-id=\"organization-role-permission-drawer\"]",
          "title": "按固定顺序排查权限异常",
          "text": "员工看不到功能时，依次检查账号状态、所属部门、绑定角色、菜单入口、操作权限和数据范围。不要直接授予全部权限来绕过问题，保存前还要复核已选数量。",
          "before": {
            "close": [
              "[data-guide-id=\"organization-role-menu-drawer\"]"
            ],
            "click": "[data-role-table-body] [data-role-permission]:not([disabled])",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"organization-role-permission-drawer\"]",
            "snapshot": "[data-guide-id=\"organization-role-permission-drawer\"]"
          },
          "readOnly": true
        },
        {
          "id": "org-employee-filters",
          "target": "[data-guide-id=\"organization-employee-filters\"]",
          "title": "创建前先检查账号、部门、角色和状态",
          "text": "通过员工ID、账号、姓名、部门、角色和状态确认账号是否已存在。重复账号会增加授权、禁用和财务归属的排查成本，本步骤只查询不修改。",
          "readOnly": true
        },
        {
          "id": "org-employee-table",
          "target": "[data-guide-id=\"organization-employee-table\"]",
          "title": "员工列表是授权结果的核对入口",
          "text": "列表同时展示账号、联系方式、钱包、部门、角色和状态。员工无法登录先查状态；能登录但功能异常，再按部门、角色、菜单、操作和数据范围逐层排查。",
          "readOnly": true
        },
        {
          "id": "org-employee-account",
          "target": "[data-guide-id=\"organization-employee-drawer\"]",
          "title": "先建立可追溯的员工登录身份",
          "text": "账号、姓名和联系方式用于识别真实操作人，初始登录信息应通过安全渠道交付。不要使用共用账号或临时测试身份承载正式业务；教程不创建员工。",
          "before": {
            "click": "[data-guide-id=\"organization-employee-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"organization-employee-drawer\"]",
            "tab": "",
            "snapshot": "[data-guide-id=\"organization-employee-drawer\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "org-employee-assignment",
          "target": "[data-guide-id=\"organization-employee-form\"]",
          "title": "部门确定归属，角色决定工作能力",
          "text": "先选择员工实际所属部门，再分配与岗位职责匹配的角色。调岗时必须同步检查旧角色是否应移除，避免权限叠加；禁用账号会立即影响登录。",
          "before": {
            "click": "[data-guide-id=\"organization-employee-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"organization-employee-drawer\"]",
            "tab": "",
            "snapshot": "[data-guide-id=\"organization-employee-drawer\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "org-commission-table",
          "target": "[data-guide-id=\"organization-commission-table\"]",
          "title": "提成规则会影响真实收入计算",
          "text": "先检查现有规则的适用员工、条件、对象、比例、状态和优先关系。重复或重叠规则可能造成重复计算；删除、停用和启用前必须确认影响人员与结算周期。",
          "readOnly": true
        },
        {
          "id": "org-commission-employees",
          "target": "[data-guide-id=\"organization-commission-employees\"]",
          "title": "先限定提成适用员工",
          "text": "先选择真正参与该业务的员工，再配置计算条件。人员范围过大会把不相关员工纳入计算，范围过小则可能漏算；教程只展示结构，不保存。",
          "before": {
            "click": "[data-guide-id=\"organization-commission-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"organization-commission-drawer\"]",
            "tab": "",
            "snapshot": "[data-guide-id=\"organization-commission-drawer\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "org-commission-conditions",
          "target": "[data-guide-id=\"organization-commission-conditions\"]",
          "title": "条件、对象、比例和发放节点共同生效",
          "text": "明确提成基于哪个业务对象、满足什么条件、按什么比例计算以及何时发放。任何一项口径不清都可能造成结算争议，应与正式制度保持一致。",
          "before": {
            "click": "[data-guide-id=\"organization-commission-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"organization-commission-drawer\"]",
            "tab": "",
            "snapshot": "[data-guide-id=\"organization-commission-drawer\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "org-commission-preview",
          "target": "[data-guide-id=\"organization-commission-preview\"]",
          "title": "启用前用预览完成最终复核",
          "text": "最后核对适用员工、触发条件、计算对象、比例和预计结果，再确认是否与其他规则重叠。完成本教程不代表规则已保存、启用或影响任何员工收入。",
          "before": {
            "click": "[data-guide-id=\"organization-commission-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"organization-commission-drawer\"]",
            "tab": "",
            "snapshot": "[data-guide-id=\"organization-commission-drawer\"]",
            "close": []
          },
          "readOnly": true
        }
      ]
    },
    {
      "id": "system-config",
      "group": "admin",
      "title": "管理系统配置",
      "description": "按系统默认值、站点品牌、问卷库、三方服务、事件、安检和高级控制理解全局配置。",
      "estimate": "约 8 分钟",
      "permission": "admin.view",
      "permissionFallback": "[href*='config'], [data-nav='配置']",
      "goals": [
        "admin"
      ],
      "steps": [
        {
          "id": "config-tabs",
          "target": "[data-guide-id=\"config-tabs\"]",
          "title": "先区分默认值、公共展示和全局控制",
          "text": "系统设置提供后续新建项目、会员和站点的默认规则，其他配置页管理问卷、外部服务、通知、安检和高级控制。修改前先确认影响对象和生效范围；教程全程不保存。",
          "readOnly": true
        },
        {
          "id": "config-base",
          "target": "[data-guide-id=\"config-basic-project\"]",
          "title": "项目首选货币和别名影响后续新建对象",
          "text": "首选货币会成为项目报价和财务核算的默认起点，别名开关影响名称展示方式。调整前应统一合同、报价和财务口径，并确认是只影响新建对象还是涉及既有数据。",
          "readOnly": true
        },
        {
          "id": "config-site-identity",
          "target": "[data-guide-id=\"config-site-identity\"]",
          "title": "站点公开信息需要统一审核",
          "text": "站点名称、描述、关键词和版权信息会出现在公开页面或搜索信息中。使用正式品牌文案并确认合规、版权和多语言口径，避免把内部测试文字发布到外部。",
          "before": {
            "tab": "[data-guide-id=\"config-tab-site\"]",
            "waitFor": "[data-guide-id=\"config-site-identity\"]"
          },
          "readOnly": true
        },
        {
          "id": "config-site-brand",
          "target": "[data-guide-id=\"config-site-brand\"]",
          "title": "Logo 与 favicon 是公开品牌资产",
          "text": "上传前确认文件来源、清晰度、尺寸和透明背景是否符合规范，并准备回退版本。替换品牌资源会影响用户识别，教程不会选择文件或执行上传。",
          "before": {
            "tab": "[data-guide-id=\"config-tab-site\"]",
            "waitFor": "[data-guide-id=\"config-site-brand\"]"
          },
          "readOnly": true
        },
        {
          "id": "config-screen-table",
          "target": "[data-guide-id=\"config-screen-table\"]",
          "title": "先确认问卷用途、题目数和使用状态",
          "text": "前置问卷用于复用筛选问题与跳转逻辑。编辑或删除前先确认是否已被项目或流程引用；列表中的默认、启用和使用状态比问卷名称更重要。",
          "readOnly": true
        },
        {
          "id": "config-screen-designer",
          "target": "[data-guide-id=\"config-screen-designer\"]",
          "title": "按“题型 → 画布 → 属性”完成问卷设计",
          "text": "先从题型工具添加问题，再在画布调整顺序，最后配置标题、选项、必填和校验属性。每次修改都应考虑已使用问卷的兼容性；教程只打开设计器。",
          "before": {
            "click": "[data-guide-id=\"config-screen-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"config-screen-new-dialog\"]",
            "tab": "[data-guide-id=\"config-screen-tab-designer\"]",
            "snapshot": "[data-guide-id=\"config-screen-new-dialog\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "config-screen-workflow",
          "target": "[data-guide-id=\"config-screen-tabs\"]",
          "title": "测试、逻辑和 JSON 按顺序验证",
          "text": "先在测试问卷中验证填写体验，再检查逻辑条件和跳转结果；只有熟悉结构时才使用JSON编辑器，并在保存前再次测试。教程不新增、同步或删除问卷。",
          "before": {
            "click": "[data-guide-id=\"config-screen-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"config-screen-new-dialog\"]",
            "tab": "[data-guide-id=\"config-screen-tab-designer\"]",
            "snapshot": "[data-guide-id=\"config-screen-new-dialog\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "config-integrations-grid",
          "target": "[data-guide-id=\"config-integrations-catalog\"]",
          "title": "先按业务用途选择三方服务",
          "text": "短信、邮件、钉钉、微信、云服务、SSO、CDN和AI等集成解决不同问题。不要因为目录中存在服务就全部启用，先确认业务责任人、会员账号和故障回退方案。",
          "readOnly": true
        },
        {
          "id": "config-integration-credentials",
          "target": "[data-guide-id=\"config-integrations-sms\"]",
          "title": "凭据先保存并保护，再决定是否启用",
          "text": "密钥、账号、签名和服务地址属于敏感配置，只能由授权管理员维护。先核对环境和凭据，再保存、测试连接，最后决定启用；教程不会读取或修改真实凭据。",
          "before": {
            "waitFor": "[data-guide-id=\"config-integrations-sms\"]",
            "snapshot": "[data-guide-id=\"config-integrations-sms\"]"
          },
          "readOnly": true
        },
        {
          "id": "config-integration-test",
          "target": "[data-guide-id=\"config-integrations-test\"]",
          "title": "连接测试不等于业务链路已经可用",
          "text": "测试通过只说明当前凭据和网络基本可达，还要验证模板、回调、额度、限流和失败告警。测试失败时先查凭据、环境、网络和服务商状态；教程不会点击测试或保存。",
          "before": {
            "waitFor": "[data-guide-id=\"config-integrations-sms\"]",
            "snapshot": "[data-guide-id=\"config-integrations-sms\"]"
          },
          "readOnly": true
        },
        {
          "id": "config-events",
          "target": "[data-guide-id=\"config-events-table\"]",
          "title": "事件、接收对象和启停状态共同决定通知",
          "text": "先明确什么业务事件需要通知，再配置负责处理的接收对象和渠道。关闭通知或选错接收人可能让合作申请、异常项目或财务待办无人处理。",
          "readOnly": true
        },
        {
          "id": "config-security-table",
          "target": "[data-guide-id=\"config-security-table\"]",
          "title": "系统安检是客户和项目规则的继承起点",
          "text": "列表中的产品、优先级、状态和规则会形成系统级基线，客户或项目可能继续继承或覆盖。先核对继承关系，再考虑启停、排序、编辑或删除。",
          "readOnly": true
        },
        {
          "id": "config-security-credentials",
          "anchorId": "config-security-product-step",
          "target": ".security-product-section",
          "title": "先选安检产品，SDK 和凭据配置才会展开",
          "text": "不同安检产品需要不同的SDK与凭据字段。先确认产品、接入方式和运行环境，再按展开后的字段核对配置；生产、测试凭据混用会导致检测失败或数据进入错误环境。教程只打开配置，不代替选择或保存。",
          "before": {
            "click": "[data-guide-id=\"config-security-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"config-security-drawer\"]",
            "tab": "",
            "snapshot": "[data-guide-id=\"config-security-drawer\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "config-security-rules",
          "anchorId": "config-security-rules-step",
          "target": ".security-dialog-body",
          "title": "前端字段、阻止规则和优先级要一起验证",
          "text": "选择产品后，抽屉会展开前端字段、凭据和默认阻止规则；底部优先级决定多条配置的执行顺序。上线前用测试项目覆盖通过、拒绝和异常场景，避免直接在生产流量上试错；教程不新增规则、不启用也不保存。",
          "before": {
            "click": "[data-guide-id=\"config-security-new\"]",
            "safeAction": "open-surface",
            "waitFor": "[data-guide-id=\"config-security-drawer\"]",
            "tab": "",
            "snapshot": "[data-guide-id=\"config-security-drawer\"]",
            "close": []
          },
          "readOnly": true
        },
        {
          "id": "config-advanced-scope",
          "target": "[data-guide-id=\"config-advanced-ir\"]",
          "title": "IR 与周期超限控制影响项目流量边界",
          "text": "IR控制用于限制不符合目标条件的流量，周期超限用于处理超出约定周期的参与。先确认统计口径、适用项目和异常处理方式，再调整系统级开关。",
          "readOnly": true
        },
        {
          "id": "config-advanced-performance",
          "target": "[data-guide-id=\"config-advanced-speed\"]",
          "title": "速度与超时控制需要结合真实链路验证",
          "text": "速度控制和超时控制会影响请求放行、终止与用户体验。应先在测试项目验证阈值、回调和异常记录；完成本教程不代表任何高级配置已经保存或发布。",
          "readOnly": true
        }
      ]
    }
  ],
  "goalTaskMap": {
    "project": [
      "interface-tour",
      "cooperation-resources",
      "project-create"
    ],
    "customer": [
      "interface-tour",
      "customer-management",
      "cooperation-resources"
    ],
    "quality": [
      "station-overview"
    ],
    "finance": [
      "finance-overview"
    ],
    "admin": [
      "organization-permissions",
      "system-config"
    ],
    "station": [
      "station-overview",
      "station-members"
    ]
  },
  "experienceStepIds": {
    "quick": {
      "interface-tour": [
        "top-nav",
        "side-nav",
        "global-search"
      ],
      "customer-management": [],
      "cooperation-resources": [],
      "project-create": [],
      "finance-overview": [],
      "station-overview": [],
      "station-members": [],
      "auxiliary-tools": [],
      "organization-permissions": [],
      "system-config": []
    },
    "new": {
      "interface-tour": [
        "top-nav",
        "side-nav",
        "global-search",
        "personal-menu",
        "quick-actions"
      ],
      "customer-management": [
        "customer-table",
        "customer-new",
        "customer-identity",
        "customer-settlement",
        "customer-risk",
        "customer-callback-s2s",
        "customer-invoice"
      ],
      "cooperation-resources": [
        "cooperation-overview",
        "cooperation-profile",
        "cooperation-customer-market",
        "cooperation-customer-detail",
        "cooperation-applications",
        "cooperation-partners",
        "cooperation-points",
        "cooperation-bills"
      ],
      "project-create": [
        "project-table",
        "project-new",
        "project-identity",
        "project-commercial",
        "project-metrics",
        "project-quota-device",
        "project-risk-security"
      ],
      "finance-overview": [
        "finance-log-table",
        "finance-employee-log",
        "finance-bill-table",
        "finance-bill-risk",
        "finance-employee-bill",
        "finance-invoice-table",
        "finance-invoice-risk"
      ],
      "station-overview": [
        "station-analysis-kpis",
        "station-analysis-charts",
        "station-analysis-table"
      ],
      "station-members": [
        "station-level-table",
        "station-group-table",
        "station-member-new",
        "station-member-drawer",
        "station-member-assignment",
        "station-member-table"
      ],
      "auxiliary-tools": [
        "auxiliary-dictionary",
        "auxiliary-uid-parse",
        "auxiliary-link-parse"
      ],
      "organization-permissions": [
        "org-department-filters",
        "org-department-table",
        "org-department-drawer",
        "org-department-permission",
        "org-department-manager",
        "org-role-table",
        "org-role-dialog",
        "org-role-menu",
        "org-role-permissions",
        "org-role-diagnostics",
        "org-employee-filters",
        "org-employee-table",
        "org-employee-account",
        "org-employee-assignment",
        "org-commission-table",
        "org-commission-employees",
        "org-commission-conditions",
        "org-commission-preview"
      ],
      "system-config": [
        "config-tabs",
        "config-base",
        "config-site-identity",
        "config-site-brand",
        "config-screen-table",
        "config-screen-designer",
        "config-screen-workflow",
        "config-integrations-grid",
        "config-integration-credentials",
        "config-integration-test",
        "config-events",
        "config-security-table",
        "config-security-credentials",
        "config-security-rules",
        "config-advanced-scope",
        "config-advanced-performance"
      ]
    },
    "similar": {
      "interface-tour": [
        "top-nav",
        "global-search",
        "quick-actions"
      ],
      "customer-management": [
        "customer-table",
        "customer-identity",
        "customer-risk",
        "customer-invoice"
      ],
      "cooperation-resources": [
        "cooperation-overview",
        "cooperation-profile",
        "cooperation-customer-market",
        "cooperation-customer-detail",
        "cooperation-applications",
        "cooperation-partners",
        "cooperation-bills"
      ],
      "project-create": [
        "project-table",
        "project-identity",
        "project-metrics",
        "project-risk-security"
      ],
      "finance-overview": [
        "finance-log-table",
        "finance-bill-table",
        "finance-employee-bill",
        "finance-invoice-risk"
      ],
      "station-overview": [
        "station-analysis-kpis",
        "station-analysis-table"
      ],
      "station-members": [
        "station-level-table",
        "station-member-new",
        "station-member-assignment",
        "station-member-table"
      ],
      "auxiliary-tools": [
        "auxiliary-dictionary",
        "auxiliary-link-parse"
      ],
      "organization-permissions": [
        "org-department-table",
        "org-department-permission",
        "org-department-manager",
        "org-role-table",
        "org-role-menu",
        "org-role-permissions",
        "org-role-diagnostics",
        "org-employee-table",
        "org-employee-assignment",
        "org-commission-table",
        "org-commission-employees",
        "org-commission-conditions",
        "org-commission-preview"
      ],
      "system-config": [
        "config-base",
        "config-site-identity",
        "config-screen-table",
        "config-screen-workflow",
        "config-integrations-grid",
        "config-integration-credentials",
        "config-integration-test",
        "config-events",
        "config-security-table",
        "config-security-rules",
        "config-advanced-scope",
        "config-advanced-performance"
      ]
    },
    "expert": {
      "interface-tour": [
        "top-nav",
        "quick-actions"
      ],
      "customer-management": [
        "customer-table",
        "customer-invoice"
      ],
      "cooperation-resources": [
        "cooperation-overview",
        "cooperation-customer-detail",
        "cooperation-applications",
        "cooperation-bills"
      ],
      "project-create": [
        "project-table",
        "project-risk-security"
      ],
      "finance-overview": [
        "finance-log-table",
        "finance-invoice-risk"
      ],
      "station-overview": [
        "station-analysis-kpis",
        "station-analysis-table"
      ],
      "station-members": [
        "station-level-table",
        "station-member-table"
      ],
      "auxiliary-tools": [
        "auxiliary-dictionary",
        "auxiliary-link-parse"
      ],
      "organization-permissions": [
        "org-department-permission",
        "org-department-manager",
        "org-role-menu",
        "org-role-permissions",
        "org-role-diagnostics",
        "org-employee-table",
        "org-employee-assignment",
        "org-commission-preview"
      ],
      "system-config": [
        "config-base",
        "config-integration-credentials",
        "config-integration-test",
        "config-events",
        "config-security-table",
        "config-security-rules",
        "config-advanced-performance"
      ]
    }
  }
},
  "2": {
    "edition": "supplier-network",
    "editionName": "供应商网络运营版",
    "guideVersion": "supplier-network-2.2.0",
    "groups": [
      {
        "id": "essential",
        "label": "上手必学",
        "description": "先理解界面和业务主线，再进入岗位任务。"
      },
      {
        "id": "role",
        "label": "岗位任务",
        "description": "按客户、项目、财务和辅助工具学习。"
      },
      {
        "id": "station",
        "label": "会员运营",
        "description": "仅在样本库运营版显示会员、站点和样本运营能力。"
      },
      {
        "id": "admin",
        "label": "管理员任务",
        "description": "仅向具备相应菜单和权限的管理员显示。"
      }
    ],
    "goalOptions": [
      {
        "id": "project",
        "label": "创建项目并完成交付",
        "hint": "学习客户、项目交付与财务主线。"
      },
      {
        "id": "customer",
        "label": "管理客户与业务规则",
        "hint": "适合客户运营岗位。"
      },
      {
        "id": "quality",
        "label": "复盘项目与质量",
        "hint": "适合质控和项目复盘。"
      },
      {
        "id": "finance",
        "label": "理解财务与结算",
        "hint": "适合财务和业务负责人。"
      },
      {
        "id": "admin",
        "label": "配置团队与系统",
        "hint": "适合系统管理员。"
      }
    ],
    "experienceOptions": [
      {
        "id": "new",
        "label": "第一次使用此类系统",
        "hint": "保留当前版本全部安全教学步骤。",
        "recommended": true
      },
      {
        "id": "similar",
        "label": "用过类似调查平台",
        "hint": "保留每项任务的主要入口和风险说明。"
      },
      {
        "id": "expert",
        "label": "已经熟悉业务流程",
        "hint": "只看关键入口和最后的风险检查。"
      }
    ],
    "taskOrder": [
      "interface-tour",
      "customer-management",
      "supplier-setup",
      "cooperation-resources",
      "project-create",
      "finance-overview",
      "auxiliary-tools",
      "organization-permissions",
      "system-config"
    ],
    "tasks": [
      {
        "id": "interface-tour",
        "group": "essential",
        "title": "60 秒业务地图",
        "description": "认识业务导航、模块侧栏、全局搜索、个人入口与快捷入口。",
        "estimate": "约 60 秒",
        "goals": [
          "project",
          "customer",
          "quality",
          "finance",
          "admin",
          "station"
        ],
        "permission": "",
        "permissionFallback": "",
        "steps": [
          {
            "id": "top-nav",
            "target": "[data-guide-id=\"top-nav\"]",
            "mobileTarget": "",
            "title": "先认清业务主线",
            "text": "客户、供应商和合作资源确定项目来源；先准备供应商等级与档案，再完成项目创建、供应商分配与调度、调查与质检、供应商账单及客户发票。组织与配置提供权限和默认规则。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "side-nav",
            "target": "[data-guide-id=\"side-nav\"]",
            "mobileTarget": "",
            "title": "当前模块的侧边导航",
            "text": "侧边栏只展示当前业务模块内的页面。进入供应商、项目、财务、记录或配置后，可先通过高亮菜单确认当前位置，再按业务顺序继续操作。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "global-search",
            "target": "[data-guide-id=\"global-search\"]",
            "mobileTarget": "",
            "title": "全局搜索",
            "text": "不确定功能在哪里时，可以按功能、帮助或数据关键字查找。搜索不会修改业务数据。",
            "interaction": "simulate",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "personal-menu",
            "target": "[data-guide-id=\"personal-menu\"]",
            "mobileTarget": "",
            "title": "个人中心与教程入口",
            "text": "这里可以进入个人设置、更新日志、新手引导与教程和安全退出。关闭右下角入口后，也能从这里重新打开。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "quick-actions",
            "target": "[data-guide-id=\"quick-actions\"]",
            "mobileTarget": "",
            "title": "四个快捷入口",
            "text": "这些入口用于快速进入新增、客户、供应商和合作资源相关页面，是导航捷径，不会替代正式配置流程。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          }
        ]
      },
      {
        "id": "customer-management",
        "group": "role",
        "title": "建立客户档案与项目规则",
        "description": "按主体、结算、风控、回调和开票顺序准备项目来源。",
        "estimate": "约 3 分钟",
        "goals": [
          "customer"
        ],
        "permission": "partner.view",
        "permissionFallback": "",
        "steps": [
          {
            "id": "customer-table",
            "target": "[data-guide-id=\"customer-table\"]",
            "mobileTarget": "",
            "title": "客户档案是项目规则来源",
            "text": "客户状态、账期、分配方式和 API 类型会影响其项目。编辑、删除或停用前先检查关联项目、账单与发票。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "customer-new",
            "target": "[data-guide-id=\"customer-new\"]",
            "mobileTarget": "",
            "title": "新增前先准备合同信息",
            "text": "先准备主体、业务联系人、币种、账期、付款规则、回调和发票资料。教程只打开配置入口，不会创建客户。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": {
              "close": [
                "[data-guide-id=\"customer-analysis\"]"
              ],
              "waitFor": "[data-guide-id=\"customer-new\"]"
            }
          },
          {
            "id": "customer-identity",
            "target": "[data-guide-id=\"customer-base-identity\"]",
            "mobileTarget": "",
            "title": "主体与联系人必须可追溯",
            "text": "名称和公司用于业务识别，联系人、手机和邮箱用于协作通知。应使用正式业务资料，不要录入临时测试或个人敏感信息。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"customer-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"customer-drawer\"]",
              "tab": "[data-guide-id=\"customer-tab-base\"]",
              "snapshot": "[data-guide-id=\"customer-drawer\"]",
              "close": []
            }
          },
          {
            "id": "customer-settlement",
            "target": "[data-guide-id=\"customer-base-settlement\"]",
            "mobileTarget": "",
            "title": "结算规则必须与合同一致",
            "text": "币种、账期和付款规则会影响项目报价、对账和发票。未与合同确认时不要保存。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"customer-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"customer-drawer\"]",
              "tab": "[data-guide-id=\"customer-tab-base\"]",
              "snapshot": "[data-guide-id=\"customer-drawer\"]",
              "close": []
            }
          },
          {
            "id": "customer-risk",
            "target": "[data-guide-id=\"customer-risk-panel\"]",
            "mobileTarget": "",
            "title": "分配、风控与安检会向项目传递",
            "text": "部门分配、客户级风险和第三方安检会影响关联项目。修改前核对继承范围、检测产品和例外，避免正常流量被拦截。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"customer-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"customer-drawer\"]",
              "tab": "[data-guide-id=\"customer-tab-risk\"]",
              "snapshot": "[data-guide-id=\"customer-drawer\"]",
              "close": []
            }
          },
          {
            "id": "customer-callback-s2s",
            "target": "[data-guide-id=\"customer-callback-s2s\"]",
            "mobileTarget": "",
            "title": "同时核对前端跳转与 S2S 回调",
            "text": "完成、配额满、筛除和安全终止既可能触发前端重定向，也可能触发服务器回调。上线前用测试项目核对 URL、UID 与状态映射；教程不发送请求。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"customer-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"customer-drawer\"]",
              "tab": "[data-guide-id=\"customer-tab-callback\"]",
              "snapshot": "[data-guide-id=\"customer-drawer\"]",
              "close": []
            }
          },
          {
            "id": "customer-invoice",
            "target": "[data-guide-id=\"customer-invoice-panel\"]",
            "mobileTarget": "",
            "title": "建档完成不等于可以开票",
            "text": "发票模板应与合同主体、税务信息和币种一致。当前客户没有保存；真实顺序是建档复核、创建项目、形成结算，再由有权限人员开票。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"customer-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"customer-drawer\"]",
              "tab": "[data-guide-id=\"customer-tab-invoice\"]",
              "snapshot": "[data-guide-id=\"customer-drawer\"]",
              "close": []
            }
          }
        ]
      },
      {
        "id": "supplier-setup",
        "group": "role",
        "title": "先定供应商等级，再建立档案",
        "description": "按等级、主体、合作范围、结算账户和回调完成供应商接入。",
        "estimate": "约 3 分钟",
        "goals": [
          "project",
          "customer"
        ],
        "permission": "supplier.view",
        "permissionFallback": "",
        "steps": [
          {
            "id": "supplier-levels",
            "target": "[data-guide-id=\"supplier-level-table\"]",
            "mobileTarget": "",
            "title": "等级规则必须先于供应商档案",
            "text": "等级承载成本、权益或管理口径。先确认等级规则，再建供应商，避免后续批量调整影响报价与结算。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "supplier-new",
            "target": "[data-guide-id=\"supplier-new\"]",
            "mobileTarget": "",
            "title": "接入前准备合同与账户资料",
            "text": "准备主体、联系人、区域、等级、币种、账期、合作范围、收款账户和回调规则。教程不会创建账号。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "supplier-identity",
            "target": "[data-guide-id=\"supplier-base-identity\"]",
            "mobileTarget": "",
            "title": "主体、账号与联系人必须可追溯",
            "text": "账户类型、公司、联系人、电话和邮箱应使用正式业务资料；密码与凭据不得进入教程日志。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"supplier-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"supplier-drawer\"]",
              "tab": "[data-guide-id=\"supplier-tab-base\"]",
              "snapshot": "[data-guide-id=\"supplier-drawer\"]",
              "close": []
            }
          },
          {
            "id": "supplier-settlement",
            "target": "[data-guide-id=\"supplier-base-settlement\"]",
            "mobileTarget": "",
            "title": "等级、币种和账期共同决定结算",
            "text": "这些字段必须与合同一致。配置错误会影响成本、钱包和账单，未复核时不要保存。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"supplier-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"supplier-drawer\"]",
              "tab": "[data-guide-id=\"supplier-tab-base\"]",
              "snapshot": "[data-guide-id=\"supplier-drawer\"]",
              "close": []
            }
          },
          {
            "id": "supplier-control",
            "target": "[data-guide-id=\"supplier-base-control\"]",
            "mobileTarget": "",
            "title": "同时确认流量类型、区域与客户范围",
            "text": "B2B/B2C、默认开放或仅指定、可用区域及客户范围共同决定供应商能接收哪些项目。教程不会切换。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"supplier-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"supplier-drawer\"]",
              "tab": "[data-guide-id=\"supplier-tab-base\"]",
              "snapshot": "[data-guide-id=\"supplier-drawer\"]",
              "close": []
            }
          },
          {
            "id": "supplier-finance-account",
            "target": "[data-guide-id=\"supplier-finance-account\"]",
            "mobileTarget": "",
            "title": "收款账户必须匹配合同主体",
            "text": "核对收款方式、账号和账户姓名，变更应走复核流程。教程不会读取、保存或测试真实账户。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"supplier-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"supplier-drawer\"]",
              "tab": "[data-guide-id=\"supplier-tab-finance\"]",
              "snapshot": "[data-guide-id=\"supplier-drawer\"]",
              "close": []
            }
          },
          {
            "id": "supplier-callback",
            "target": "[data-guide-id=\"supplier-callback-panel\"]",
            "mobileTarget": "",
            "title": "回调上线前先做状态映射测试",
            "text": "完成、配额满、筛除和安全终止要与 URL、UID 和下游状态一致。教程不会保存或发送测试请求。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"supplier-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"supplier-drawer\"]",
              "tab": "[data-guide-id=\"supplier-tab-callback\"]",
              "snapshot": "[data-guide-id=\"supplier-drawer\"]",
              "close": []
            }
          }
        ]
      },
      {
        "id": "cooperation-resources",
        "group": "role",
        "title": "管理合作资源",
        "description": "从对外资料、云供应商与云客户筛选开始，建立合作关系并追踪积分与账单。",
        "estimate": "约 5 分钟",
        "goals": [
          "customer",
          "project"
        ],
        "permission": "partner.view",
        "permissionFallback": "",
        "steps": [
          {
            "id": "cooperation-overview",
            "target": ".coop-my-overview",
            "mobileTarget": "",
            "title": "先理解合作资源闭环",
            "text": "正确顺序是：完善对外资料 → 在云资源中筛选对象并核对详情 → 发起或处理合作申请 → 申请通过后维护合作关系 → 在积分和账单中追踪资源消耗。教程只讲解流程，不会自动申请、接受、拒绝、解锁或付款。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "cooperation-profile",
            "target": "[data-my-panel=\"profile\"]",
            "mobileTarget": "",
            "title": "先完善对外资料与开放范围",
            "text": "名称、简介、业务区域、联系信息和公开能力决定合作方看到的企业身份；云资源开放范围决定可发现的合作对象。请先核对真实性和可公开性，再由有权限人员保存，教程不会提交资料或切换开放状态。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-my-tab=\"profile\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-my-panel=\"profile\"]:not([hidden])",
              "snapshot": "[data-my-panel=\"profile\"]"
            }
          },
          {
            "id": "cooperation-supplier-market",
            "target": ".coop-market-card",
            "mobileTarget": "",
            "title": "筛选云供应商候选资源",
            "text": "先按地区、能力、评分和合作状态缩小范围，再比较项目承接、完成率、响应速度与合作评价。列表指标用于初筛，不能替代合同、交付能力和数据安全审核。",
            "interaction": "simulate",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "close": [
                "[data-coop-detail-layer]"
              ],
              "waitFor": ".coop-market-card"
            }
          },
          {
            "id": "cooperation-supplier-detail",
            "target": ".coop-detail-drawer",
            "mobileTarget": "",
            "title": "核对供应商详情再决定合作",
            "text": "详情中的企业资料、服务区域、交付指标、评价和历史表现需要交叉核对。解锁联系方式、发送消息或发起合作申请会产生真实业务影响，本教程只打开详情，不会执行这些操作。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-coop-detail]",
              "safeAction": "open-surface",
              "waitFor": "[data-coop-detail-layer][aria-hidden=\"false\"] .coop-detail-drawer",
              "snapshot": ".coop-detail-drawer"
            }
          },
          {
            "id": "cooperation-customer-market",
            "target": ".coop-market-card",
            "mobileTarget": "",
            "title": "筛选云客户合作机会",
            "text": "先按地区、行业、评分和合作状态筛选，再比较项目发布、结算表现、响应速度和合作评价。高需求量不等于低风险，仍需确认需求真实性、结算条件与交付边界。",
            "interaction": "simulate",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "close": [
                "[data-coop-detail-layer]"
              ],
              "waitFor": ".coop-market-card"
            }
          },
          {
            "id": "cooperation-customer-detail",
            "target": ".coop-detail-drawer",
            "mobileTarget": "",
            "title": "核对客户详情与合作条件",
            "text": "重点核对企业资料、项目机会、结算表现、评价和公开联系方式。解锁、发送消息或申请合作前，应确认负责人、合同主体和回款条件；教程只展示详情，不会提交任何申请。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-coop-detail]",
              "safeAction": "open-surface",
              "waitFor": "[data-coop-detail-layer][aria-hidden=\"false\"] .coop-detail-drawer",
              "snapshot": ".coop-detail-drawer"
            }
          },
          {
            "id": "cooperation-applications",
            "target": "[data-my-panel=\"sent\"]",
            "mobileTarget": "",
            "title": "按方向和状态处理合作申请",
            "text": "收到的申请用于判断是否接受外部合作，发出的申请用于追踪对方处理结果。先核对申请方、合作目的、负责人和当前状态；接受、拒绝、撤回或再次申请都必须由用户主动确认。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-my-tab=\"sent\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-my-panel=\"sent\"]:not([hidden])",
              "snapshot": "[data-my-panel=\"sent\"]"
            }
          },
          {
            "id": "cooperation-partners",
            "target": "[data-my-panel=\"partners\"]",
            "mobileTarget": "",
            "title": "申请通过后才进入合作关系",
            "text": "只有通过的合作申请才会形成正式合作关系。这里用于核对合作对象、合作状态和后续沟通入口；暂停或解除关系前，应先确认正在执行的项目、账务和双方负责人。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-my-tab=\"partners\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-my-panel=\"partners\"]:not([hidden])",
              "snapshot": "[data-my-panel=\"partners\"]"
            }
          },
          {
            "id": "cooperation-points",
            "target": "[data-my-panel=\"points\"]",
            "mobileTarget": "",
            "title": "用积分明细追踪资源消耗",
            "text": "积分通常与资料解锁、合作触达等资源动作相关。按时间、业务类型和变动方向核对来源，出现异常时先回查对应合作对象和操作记录；教程不会消耗或调整积分。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-my-tab=\"points\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-my-panel=\"points\"]:not([hidden])",
              "snapshot": "[data-my-panel=\"points\"]"
            }
          },
          {
            "id": "cooperation-bills",
            "target": "[data-my-panel=\"bills\"]",
            "mobileTarget": "",
            "title": "最后核对合作账单",
            "text": "按账单周期、合作对象、币种、金额和状态核对费用，并与积分明细、合同及实际合作动作保持一致。支付、确认或争议处理会影响真实账务，必须由有权限人员复核，教程不会代为操作。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-my-tab=\"bills\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-my-panel=\"bills\"]:not([hidden])",
              "snapshot": "[data-my-panel=\"bills\"]"
            }
          }
        ]
      },
      {
        "id": "project-create",
        "group": "role",
        "title": "创建项目与发布前检查",
        "description": "按归属、商业参数、入口、配额和风控完成发布前核对。",
        "estimate": "约 3 分钟",
        "goals": [
          "project"
        ],
        "permission": "project.view",
        "permissionFallback": "",
        "steps": [
          {
            "id": "project-table",
            "target": "[data-guide-id=\"project-table\"]",
            "mobileTarget": "",
            "title": "先区分草稿、运行与结束状态",
            "text": "上架、下架、分配和删除会改变真实业务。操作前核对项目主体、客户、价格、目标量和当前状态，教程不会点击行操作。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "project-new",
            "target": "[data-guide-id=\"project-new\"]",
            "mobileTarget": "",
            "title": "资料齐全后再创建",
            "text": "先准备客户归属、国家、币种、CPI、LOI、IR、项目 URL、配额与风险规则。教程只介绍入口，不会新增或保存项目。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "project-identity",
            "target": "[data-guide-id=\"project-base-identity\"]",
            "mobileTarget": "",
            "title": "项目归属决定后续对账",
            "text": "项目代码用于追踪，客户决定需求与结算来源，国家和币种决定交付口径。三者应与合同和外部问卷一致。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"project-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"project-drawer\"]",
              "tab": "[data-guide-id=\"project-tab-base\"]",
              "snapshot": "[data-guide-id=\"project-drawer\"]",
              "close": []
            }
          },
          {
            "id": "project-commercial",
            "target": "[data-guide-id=\"project-base-commercial\"]",
            "mobileTarget": "",
            "title": "确认价格与供应商分配边界",
            "text": "核对 CPI、付款规则和供应商分配方式。B2B/B2C、激活、置顶和路由检查会影响真实流量；教程不会切换。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"project-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"project-drawer\"]",
              "tab": "[data-guide-id=\"project-tab-base\"]",
              "snapshot": "[data-guide-id=\"project-drawer\"]",
              "close": []
            }
          },
          {
            "id": "project-metrics",
            "target": "[data-guide-id=\"project-base-metrics\"]",
            "mobileTarget": "",
            "title": "入口参数与交付指标要一致",
            "text": "LOI、IR、目标量和项目 URL 共同决定交付预期；URL 中的 UID 占位符必须保留。附件只上传必要资料，上线前应完成测试跳转。",
            "interaction": "",
            "readOnly": false,
            "risk": "external-link",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"project-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"project-drawer\"]",
              "tab": "[data-guide-id=\"project-tab-base\"]",
              "snapshot": "[data-guide-id=\"project-drawer\"]",
              "close": []
            }
          },
          {
            "id": "project-quota-device",
            "target": "[data-guide-id=\"project-quota-device\"]",
            "mobileTarget": "",
            "title": "把准入、配额、互斥和筛选一起核对",
            "text": "设备准入、总配额、分设备配额、项目互斥和前置筛选必须互相一致；任一处冲突都可能造成误拦截或无可用配额。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"project-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"project-drawer\"]",
              "tab": "[data-guide-id=\"project-tab-quota\"]",
              "snapshot": "[data-guide-id=\"project-drawer\"]",
              "close": []
            }
          },
          {
            "id": "project-risk-security",
            "target": "[data-guide-id=\"project-risk-security\"]",
            "mobileTarget": "",
            "title": "完成风控检查仍不等于已发布",
            "text": "内部检测、小时限流、IP/设备和第三方安检会叠加影响参与。先与客户级规则核对，再保存草稿、测试 URL 与回调，最后由有权限人员发布；教程不会提交。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"project-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"project-drawer\"]",
              "tab": "[data-guide-id=\"project-tab-risk\"]",
              "snapshot": "[data-guide-id=\"project-drawer\"]",
              "close": []
            }
          }
        ]
      },
      {
        "id": "finance-overview",
        "group": "role",
        "title": "供应商、员工与客户财务链路",
        "description": "从财务日志追溯变动，再生成账单和客户发票。",
        "estimate": "约 3 分钟",
        "goals": [
          "finance"
        ],
        "permission": "finance.view",
        "permissionFallback": "",
        "steps": [
          {
            "id": "finance-log-table",
            "target": "[data-guide-id=\"finance-supplier-log-table\"]",
            "mobileTarget": "",
            "title": "供应商财务日志是变动依据",
            "text": "先按项目、供应商、类型和时间核对收入、支出及余额变化。日志用于解释账单来源，不应直接凭当前余额判断结算。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "finance-employee-log",
            "target": ".dashboard-page",
            "mobileTarget": "",
            "title": "员工财务日志独立核对",
            "text": "员工提成或调整应先在员工财务日志确认来源、对象和时间，再进入员工账单。教程不会新增或修改流水。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "finance-bill-table",
            "target": "[data-guide-id=\"finance-supplier-bill-table\"]",
            "mobileTarget": "",
            "title": "供应商账单汇总可结算明细",
            "text": "账单把已确认的供应商财务明细按周期汇总。创建前核对币种、金额、状态与异常记录，避免重复结算。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "finance-bill-risk",
            "target": "[data-guide-id=\"finance-supplier-bill-risk-actions\"]",
            "mobileTarget": "",
            "title": "创建、审核与支付必须分权复核",
            "text": "新增、批量审核、拒绝、支付和删除都会改变真实财务状态。先核对明细、周期和审批人；教程只讲解，不执行。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "finance-employee-bill",
            "target": ".dashboard-page",
            "mobileTarget": "",
            "title": "员工账单承接已确认的员工流水",
            "text": "先核对提成规则与员工财务日志，再生成、审核或支付员工账单；不要把员工账单与外部合作方账单混用。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "finance-invoice-table",
            "target": "[data-guide-id=\"finance-customer-invoice-table\"]",
            "mobileTarget": "",
            "title": "客户发票建立在已确认结算之上",
            "text": "先完成项目结算并核对供应商与员工成本，再按客户、币种、金额和合同主体准备发票。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "finance-invoice-risk",
            "target": "[data-guide-id=\"finance-customer-invoice-risk-actions\"]",
            "mobileTarget": "",
            "title": "开票、作废与删除都要二次确认",
            "text": "开票、批量处理、作废和删除会影响真实财务与税务记录。操作前核对审批状态和合同主体；教程不会点击。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          }
        ]
      },
      {
        "id": "auxiliary-tools",
        "group": "role",
        "title": "用辅助工具排查异常",
        "description": "只保留会影响业务判断的数据字典、UID、IP 和链路工具。",
        "estimate": "约 4 分钟",
        "goals": [
          "quality",
          "admin"
        ],
        "permission": "",
        "permissionFallback": "",
        "steps": [
          {
            "id": "auxiliary-dictionary",
            "target": ".dashboard-page",
            "mobileTarget": "",
            "title": "先核对公共数据字典",
            "text": "字典值可能被项目、回调或报表共同引用；新增、修改或删除前先确认使用范围，教程不会保存。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "auxiliary-ip-query",
            "target": ".dashboard-page",
            "mobileTarget": "",
            "title": "IP 只作为排查线索",
            "text": "IP 查询可辅助判断区域与网络异常，但不能单独作为拒绝、处罚或质检结论。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "auxiliary-uid-parse",
            "target": ".dashboard-page",
            "mobileTarget": "",
            "title": "UID 解析与分拣",
            "text": "先确认来源格式和数据权限，再解析或分拣 UID；结果用于定位记录，不会替代原始参与记录。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "auxiliary-link-parse",
            "target": ".dashboard-page",
            "mobileTarget": "",
            "title": "用链路解析定位跳转异常",
            "text": "核对项目 URL、UID 占位符、回调状态和最终地址；不要在工具中粘贴无关敏感参数。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          }
        ]
      },
      {
        "id": "organization-permissions",
        "group": "admin",
        "title": "配置团队与权限",
        "description": "按部门层级、角色权限、员工授权和提成规则的正确顺序完成团队配置。",
        "estimate": "约 9 分钟",
        "goals": [
          "admin"
        ],
        "permission": "admin.view",
        "permissionFallback": "[href*='organization-'], [data-nav='组织']",
        "steps": [
          {
            "id": "org-department-filters",
            "target": "[data-guide-id=\"organization-department-filters\"]",
            "mobileTarget": "",
            "title": "先按“部门 → 角色 → 员工”配置",
            "text": "部门确定组织归属和管理边界，角色复用菜单、操作与数据权限，员工最后绑定部门和角色。先检查已有部门，避免重复建档或把员工挂到错误层级。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "org-department-table",
            "target": "[data-guide-id=\"organization-department-table\"]",
            "mobileTarget": "",
            "title": "先从层级、主管和人数判断影响范围",
            "text": "重点核对上级部门、主管、员工数和状态。调整上级关系会改变组织层级；删除或停用前必须先确认下级部门、在岗员工和业务负责人。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "org-department-drawer",
            "target": "[data-guide-id=\"organization-department-drawer\"]",
            "mobileTarget": "",
            "title": "部门基本信息决定归属关系",
            "text": "新增时先填写稳定、可识别的部门名称，再选择正确的上级部门。层级选错会影响员工归属、主管管理范围和后续权限排查；教程只打开抽屉，不保存。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"organization-department-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-department-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"organization-department-drawer\"]",
              "close": []
            }
          },
          {
            "id": "org-department-permission",
            "target": "[data-guide-id=\"organization-department-permissions\"]",
            "mobileTarget": "",
            "title": "部门权限只授予团队必需能力",
            "text": "部门权限用于限定该组织单元的基础业务边界，不等同于员工最终权限。先按部门职责选择最小范围，再由角色补充岗位所需菜单和操作能力。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"organization-department-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-department-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"organization-department-drawer\"]",
              "close": []
            }
          },
          {
            "id": "org-department-manager",
            "target": "[data-guide-id=\"organization-department-managers\"]",
            "mobileTarget": "",
            "title": "主管承担管理职责，不代替角色授权",
            "text": "主管用于明确部门负责人和管理责任，但成为主管不代表自动拥有全部菜单、操作或数据权限。保存前分别核对主管人选、角色和数据范围。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"organization-department-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-department-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"organization-department-drawer\"]",
              "close": []
            }
          },
          {
            "id": "org-role-table",
            "target": "[data-guide-id=\"organization-role-table\"]",
            "mobileTarget": "",
            "title": "角色代表岗位职责，不代表组织归属",
            "text": "部门回答“员工属于哪里”，角色回答“员工能做什么”。先复用职责相同的现有角色，避免创建名称不同但权限重复的角色；本步骤不编辑或删除。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "org-role-dialog",
            "target": "[data-guide-id=\"organization-role-new-dialog\"]",
            "mobileTarget": "",
            "title": "按岗位职责命名角色",
            "text": "角色名称应能直接反映岗位职责，例如项目运营、财务审核或质量管理员。不要用员工姓名命名长期角色；教程只打开弹窗，不创建角色。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"organization-role-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-role-new-dialog\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"organization-role-new-dialog\"]",
              "close": []
            }
          },
          {
            "id": "org-role-menu",
            "target": "[data-guide-id=\"organization-role-menu-panel\"]",
            "mobileTarget": "",
            "title": "菜单权限决定能否进入页面",
            "text": "先为岗位保留完成工作必需的页面入口。菜单未授权时员工看不到页面；只授权菜单但没有操作权限时，员工可能能进入页面却无法执行按钮操作。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "close": [
                "[data-guide-id=\"organization-role-new-dialog\"]"
              ],
              "click": "[data-role-table-body] [data-role-menu]:not([disabled])",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-role-menu-drawer\"]",
              "snapshot": "[data-guide-id=\"organization-role-menu-drawer\"]"
            }
          },
          {
            "id": "org-role-permissions",
            "target": "[data-guide-id=\"organization-role-permission-panel\"]",
            "mobileTarget": "",
            "title": "操作权限与数据范围必须分别核对",
            "text": "操作权限决定可新增、编辑、审核、删除或导出什么；数据权限决定能看到哪些客户、供应商、项目或团队数据。两者缺一都可能造成工作受阻或越权。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "close": [
                "[data-guide-id=\"organization-role-menu-drawer\"]"
              ],
              "click": "[data-role-table-body] [data-role-permission]:not([disabled])",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-role-permission-drawer\"]",
              "snapshot": "[data-guide-id=\"organization-role-permission-drawer\"]"
            }
          },
          {
            "id": "org-role-diagnostics",
            "target": "[data-guide-id=\"organization-role-permission-drawer\"]",
            "mobileTarget": "",
            "title": "按固定顺序排查权限异常",
            "text": "员工看不到功能时，依次检查账号状态、所属部门、绑定角色、菜单入口、操作权限和数据范围。不要直接授予全部权限来绕过问题，保存前还要复核已选数量。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "close": [
                "[data-guide-id=\"organization-role-menu-drawer\"]"
              ],
              "click": "[data-role-table-body] [data-role-permission]:not([disabled])",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-role-permission-drawer\"]",
              "snapshot": "[data-guide-id=\"organization-role-permission-drawer\"]"
            }
          },
          {
            "id": "org-employee-filters",
            "target": "[data-guide-id=\"organization-employee-filters\"]",
            "mobileTarget": "",
            "title": "创建前先检查账号、部门、角色和状态",
            "text": "通过员工ID、账号、姓名、部门、角色和状态确认账号是否已存在。重复账号会增加授权、禁用和财务归属的排查成本，本步骤只查询不修改。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "org-employee-table",
            "target": "[data-guide-id=\"organization-employee-table\"]",
            "mobileTarget": "",
            "title": "员工列表是授权结果的核对入口",
            "text": "列表同时展示账号、联系方式、钱包、部门、角色和状态。员工无法登录先查状态；能登录但功能异常，再按部门、角色、菜单、操作和数据范围逐层排查。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "org-employee-account",
            "target": "[data-guide-id=\"organization-employee-drawer\"]",
            "mobileTarget": "",
            "title": "先建立可追溯的员工登录身份",
            "text": "账号、姓名和联系方式用于识别真实操作人，初始登录信息应通过安全渠道交付。不要使用共用账号或临时测试身份承载正式业务；教程不创建员工。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"organization-employee-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-employee-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"organization-employee-drawer\"]",
              "close": []
            }
          },
          {
            "id": "org-employee-assignment",
            "target": "[data-guide-id=\"organization-employee-form\"]",
            "mobileTarget": "",
            "title": "部门确定归属，角色决定工作能力",
            "text": "先选择员工实际所属部门，再分配与岗位职责匹配的角色。调岗时必须同步检查旧角色是否应移除，避免权限叠加；禁用账号会立即影响登录。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"organization-employee-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-employee-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"organization-employee-drawer\"]",
              "close": []
            }
          },
          {
            "id": "org-commission-table",
            "target": "[data-guide-id=\"organization-commission-table\"]",
            "mobileTarget": "",
            "title": "提成规则会影响真实收入计算",
            "text": "先检查现有规则的适用员工、条件、对象、比例、状态和优先关系。重复或重叠规则可能造成重复计算；删除、停用和启用前必须确认影响人员与结算周期。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "org-commission-employees",
            "target": "[data-guide-id=\"organization-commission-employees\"]",
            "mobileTarget": "",
            "title": "先限定提成适用员工",
            "text": "先选择真正参与该业务的员工，再配置计算条件。人员范围过大会把不相关员工纳入计算，范围过小则可能漏算；教程只展示结构，不保存。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"organization-commission-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-commission-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"organization-commission-drawer\"]",
              "close": []
            }
          },
          {
            "id": "org-commission-conditions",
            "target": "[data-guide-id=\"organization-commission-conditions\"]",
            "mobileTarget": "",
            "title": "条件、对象、比例和发放节点共同生效",
            "text": "明确提成基于哪个业务对象、满足什么条件、按什么比例计算以及何时发放。任何一项口径不清都可能造成结算争议，应与正式制度保持一致。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"organization-commission-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-commission-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"organization-commission-drawer\"]",
              "close": []
            }
          },
          {
            "id": "org-commission-preview",
            "target": "[data-guide-id=\"organization-commission-preview\"]",
            "mobileTarget": "",
            "title": "启用前用预览完成最终复核",
            "text": "最后核对适用员工、触发条件、计算对象、比例和预计结果，再确认是否与其他规则重叠。完成本教程不代表规则已保存、启用或影响任何员工收入。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"organization-commission-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-commission-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"organization-commission-drawer\"]",
              "close": []
            }
          }
        ]
      },
      {
        "id": "system-config",
        "group": "admin",
        "title": "管理系统配置",
        "description": "按系统默认值、供应商准入与结算、问卷库、三方服务、事件和安检理解全局配置。",
        "estimate": "约 7 分钟",
        "goals": [
          "admin"
        ],
        "permission": "admin.view",
        "permissionFallback": "[href*='config'], [data-nav='配置']",
        "steps": [
          {
            "id": "config-tabs",
            "target": "[data-guide-id=\"config-tabs\"]",
            "mobileTarget": "",
            "title": "先区分默认值、公共展示和全局控制",
            "text": "系统设置提供后续新建项目、供应商和站点的默认规则，其他配置页管理问卷、外部服务、通知、安检和高级控制。修改前先确认影响对象和生效范围；教程全程不保存。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "config-base",
            "target": "[data-guide-id=\"config-basic-project\"]",
            "mobileTarget": "",
            "title": "项目首选货币和别名影响后续新建对象",
            "text": "首选货币会成为项目报价和财务核算的默认起点，别名开关影响名称展示方式。调整前应统一合同、报价和财务口径，并确认是只影响新建对象还是涉及既有数据。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "config-supplier-registration",
            "target": "[data-guide-id=\"config-supplier-access\"]",
            "mobileTarget": "",
            "title": "注册状态决定供应商能否进入业务流程",
            "text": "“直接通过”允许注册后进入系统，“审核通过”需要管理员确认，“禁止注册”关闭入口。选择前应明确准入制度、审核责任人和异常申请处理方式。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "tab": "[data-guide-id=\"config-tab-supplier\"]",
              "waitFor": "[data-guide-id=\"config-supplier-access\"]"
            }
          },
          {
            "id": "config-supplier-settlement",
            "target": "[data-guide-id=\"config-supplier-access\"]",
            "mobileTarget": "",
            "title": "最低结算金额和税率必须与财务制度一致",
            "text": "最低结算金额决定何时可以发起账单或结算，税率会影响财务计算与对账。修改前核对合同、币种和历史账单处理规则，教程不会更改数值。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "tab": "[data-guide-id=\"config-tab-supplier\"]",
              "waitFor": "[data-guide-id=\"config-supplier-access\"]"
            }
          },
          {
            "id": "config-screen-table",
            "target": "[data-guide-id=\"config-screen-table\"]",
            "mobileTarget": "",
            "title": "先确认问卷用途、题目数和使用状态",
            "text": "前置问卷用于复用筛选问题与跳转逻辑。编辑或删除前先确认是否已被项目或流程引用；列表中的默认、启用和使用状态比问卷名称更重要。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "config-screen-designer",
            "target": "[data-guide-id=\"config-screen-designer\"]",
            "mobileTarget": "",
            "title": "按“题型 → 画布 → 属性”完成问卷设计",
            "text": "先从题型工具添加问题，再在画布调整顺序，最后配置标题、选项、必填和校验属性。每次修改都应考虑已使用问卷的兼容性；教程只打开设计器。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"config-screen-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"config-screen-new-dialog\"]",
              "tab": "[data-guide-id=\"config-screen-tab-designer\"]",
              "snapshot": "[data-guide-id=\"config-screen-new-dialog\"]",
              "close": []
            }
          },
          {
            "id": "config-screen-workflow",
            "target": "[data-guide-id=\"config-screen-tabs\"]",
            "mobileTarget": "",
            "title": "测试、逻辑和 JSON 按顺序验证",
            "text": "先在测试问卷中验证填写体验，再检查逻辑条件和跳转结果；只有熟悉结构时才使用JSON编辑器，并在保存前再次测试。教程不新增、同步或删除问卷。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"config-screen-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"config-screen-new-dialog\"]",
              "tab": "[data-guide-id=\"config-screen-tab-designer\"]",
              "snapshot": "[data-guide-id=\"config-screen-new-dialog\"]",
              "close": []
            }
          },
          {
            "id": "config-integrations-grid",
            "target": "[data-guide-id=\"config-integrations-catalog\"]",
            "mobileTarget": "",
            "title": "先按业务用途选择三方服务",
            "text": "短信、邮件、钉钉、微信、云服务、SSO、CDN和AI等集成解决不同问题。不要因为目录中存在服务就全部启用，先确认业务责任人、供应商账号和故障回退方案。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "config-integration-credentials",
            "target": "[data-guide-id=\"config-integrations-sms\"]",
            "mobileTarget": "",
            "title": "凭据先保存并保护，再决定是否启用",
            "text": "密钥、账号、签名和服务地址属于敏感配置，只能由授权管理员维护。先核对环境和凭据，再保存、测试连接，最后决定启用；教程不会读取或修改真实凭据。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "waitFor": "[data-guide-id=\"config-integrations-sms\"]",
              "snapshot": "[data-guide-id=\"config-integrations-sms\"]"
            }
          },
          {
            "id": "config-integration-test",
            "target": "[data-guide-id=\"config-integrations-test\"]",
            "mobileTarget": "",
            "title": "连接测试不等于业务链路已经可用",
            "text": "测试通过只说明当前凭据和网络基本可达，还要验证模板、回调、额度、限流和失败告警。测试失败时先查凭据、环境、网络和服务商状态；教程不会点击测试或保存。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "waitFor": "[data-guide-id=\"config-integrations-sms\"]",
              "snapshot": "[data-guide-id=\"config-integrations-sms\"]"
            }
          },
          {
            "id": "config-events",
            "target": "[data-guide-id=\"config-events-table\"]",
            "mobileTarget": "",
            "title": "事件、接收对象和启停状态共同决定通知",
            "text": "先明确什么业务事件需要通知，再配置负责处理的接收对象和渠道。关闭通知或选错接收人可能让合作申请、异常项目或财务待办无人处理。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "config-security-table",
            "target": "[data-guide-id=\"config-security-table\"]",
            "mobileTarget": "",
            "title": "系统安检是客户和项目规则的继承起点",
            "text": "列表中的产品、优先级、状态和规则会形成系统级基线，客户或项目可能继续继承或覆盖。先核对继承关系，再考虑启停、排序、编辑或删除。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "config-security-credentials",
            "target": ".security-product-section",
            "mobileTarget": "",
            "title": "先选安检产品，SDK 和凭据配置才会展开",
            "text": "不同安检产品需要不同的SDK与凭据字段。先确认产品、接入方式和运行环境，再按展开后的字段核对配置；生产、测试凭据混用会导致检测失败或数据进入错误环境。教程只打开配置，不代替选择或保存。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"config-security-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"config-security-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"config-security-drawer\"]",
              "close": []
            }
          },
          {
            "id": "config-security-rules",
            "target": ".security-dialog-body",
            "mobileTarget": "",
            "title": "前端字段、阻止规则和优先级要一起验证",
            "text": "选择产品后，抽屉会展开前端字段、凭据和默认阻止规则；底部优先级决定多条配置的执行顺序。上线前用测试项目覆盖通过、拒绝和异常场景，避免直接在生产流量上试错；教程不新增规则、不启用也不保存。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"config-security-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"config-security-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"config-security-drawer\"]",
              "close": []
            }
          }
        ]
      }
    ],
    "goalTaskMap": {
      "project": [
        "interface-tour",
        "supplier-setup",
        "cooperation-resources",
        "project-create"
      ],
      "customer": [
        "interface-tour",
        "customer-management",
        "cooperation-resources"
      ],
      "quality": [
        "project-create",
        "auxiliary-tools"
      ],
      "finance": [
        "finance-overview"
      ],
      "admin": [
        "organization-permissions",
        "system-config"
      ]
    },
    "experienceStepIds": {
      "quick": {
        "interface-tour": [
          "top-nav",
          "side-nav",
          "global-search"
        ],
        "customer-management": [],
        "supplier-setup": [],
        "cooperation-resources": [],
        "project-create": [],
        "finance-overview": [],
        "auxiliary-tools": [],
        "organization-permissions": [],
        "system-config": []
      },
      "new": {
        "interface-tour": [
          "top-nav",
          "side-nav",
          "global-search",
          "personal-menu",
          "quick-actions"
        ],
        "customer-management": [
          "customer-table",
          "customer-new",
          "customer-identity",
          "customer-settlement",
          "customer-risk",
          "customer-callback-s2s",
          "customer-invoice"
        ],
        "supplier-setup": [
          "supplier-levels",
          "supplier-new",
          "supplier-identity",
          "supplier-settlement",
          "supplier-control",
          "supplier-finance-account",
          "supplier-callback"
        ],
        "cooperation-resources": [
          "cooperation-overview",
          "cooperation-profile",
          "cooperation-supplier-market",
          "cooperation-supplier-detail",
          "cooperation-customer-market",
          "cooperation-customer-detail",
          "cooperation-applications",
          "cooperation-partners",
          "cooperation-points",
          "cooperation-bills"
        ],
        "project-create": [
          "project-table",
          "project-new",
          "project-identity",
          "project-commercial",
          "project-metrics",
          "project-quota-device",
          "project-risk-security"
        ],
        "finance-overview": [
          "finance-log-table",
          "finance-employee-log",
          "finance-bill-table",
          "finance-bill-risk",
          "finance-employee-bill",
          "finance-invoice-table",
          "finance-invoice-risk"
        ],
        "auxiliary-tools": [
          "auxiliary-dictionary",
          "auxiliary-ip-query",
          "auxiliary-uid-parse",
          "auxiliary-link-parse"
        ],
        "organization-permissions": [
          "org-department-filters",
          "org-department-table",
          "org-department-drawer",
          "org-department-permission",
          "org-department-manager",
          "org-role-table",
          "org-role-dialog",
          "org-role-menu",
          "org-role-permissions",
          "org-role-diagnostics",
          "org-employee-filters",
          "org-employee-table",
          "org-employee-account",
          "org-employee-assignment",
          "org-commission-table",
          "org-commission-employees",
          "org-commission-conditions",
          "org-commission-preview"
        ],
        "system-config": [
          "config-tabs",
          "config-base",
          "config-supplier-registration",
          "config-supplier-settlement",
          "config-screen-table",
          "config-screen-designer",
          "config-screen-workflow",
          "config-integrations-grid",
          "config-integration-credentials",
          "config-integration-test",
          "config-events",
          "config-security-table",
          "config-security-credentials",
          "config-security-rules"
        ]
      },
      "similar": {
        "interface-tour": [
          "top-nav",
          "global-search",
          "quick-actions"
        ],
        "customer-management": [
          "customer-table",
          "customer-identity",
          "customer-risk",
          "customer-invoice"
        ],
        "supplier-setup": [
          "supplier-levels",
          "supplier-identity",
          "supplier-control",
          "supplier-callback"
        ],
        "cooperation-resources": [
          "cooperation-overview",
          "cooperation-profile",
          "cooperation-supplier-market",
          "cooperation-supplier-detail",
          "cooperation-customer-market",
          "cooperation-customer-detail",
          "cooperation-applications",
          "cooperation-partners",
          "cooperation-bills"
        ],
        "project-create": [
          "project-table",
          "project-identity",
          "project-metrics",
          "project-risk-security"
        ],
        "finance-overview": [
          "finance-log-table",
          "finance-bill-table",
          "finance-employee-bill",
          "finance-invoice-risk"
        ],
        "auxiliary-tools": [
          "auxiliary-dictionary",
          "auxiliary-uid-parse",
          "auxiliary-link-parse"
        ],
        "organization-permissions": [
          "org-department-table",
          "org-department-permission",
          "org-department-manager",
          "org-role-table",
          "org-role-menu",
          "org-role-permissions",
          "org-role-diagnostics",
          "org-employee-table",
          "org-employee-assignment",
          "org-commission-table",
          "org-commission-employees",
          "org-commission-conditions",
          "org-commission-preview"
        ],
        "system-config": [
          "config-base",
          "config-supplier-registration",
          "config-supplier-settlement",
          "config-screen-table",
          "config-screen-workflow",
          "config-integrations-grid",
          "config-integration-credentials",
          "config-integration-test",
          "config-events",
          "config-security-table",
          "config-security-rules"
        ]
      },
      "expert": {
        "interface-tour": [
          "top-nav",
          "quick-actions"
        ],
        "customer-management": [
          "customer-table",
          "customer-invoice"
        ],
        "supplier-setup": [
          "supplier-levels",
          "supplier-callback"
        ],
        "cooperation-resources": [
          "cooperation-overview",
          "cooperation-supplier-detail",
          "cooperation-customer-detail",
          "cooperation-applications",
          "cooperation-bills"
        ],
        "project-create": [
          "project-table",
          "project-risk-security"
        ],
        "finance-overview": [
          "finance-log-table",
          "finance-invoice-risk"
        ],
        "auxiliary-tools": [
          "auxiliary-dictionary",
          "auxiliary-link-parse"
        ],
        "organization-permissions": [
          "org-department-permission",
          "org-department-manager",
          "org-role-menu",
          "org-role-permissions",
          "org-role-diagnostics",
          "org-employee-table",
          "org-employee-assignment",
          "org-commission-preview"
        ],
        "system-config": [
          "config-base",
          "config-supplier-registration",
          "config-integration-credentials",
          "config-integration-test",
          "config-events",
          "config-security-table",
          "config-security-rules"
        ]
      }
    }
  },
  "3": {
    "edition": "enterprise",
    "guideVersion": "enterprise-1.5.0",
    "groups": [
      {
        "id": "essential",
        "label": "上手必学",
        "description": "先理解业务闭环，再认识项目配置与发布前检查"
      },
      {
        "id": "role",
        "label": "岗位任务",
        "description": "按客户、供应商、质检和财务目标学习"
      },
      {
        "id": "station",
        "label": "调查站任务",
        "description": "只讲调查站独有的会员与站点运营能力"
      },
      {
        "id": "admin",
        "label": "管理员任务",
        "description": "仅向拥有相应权限的管理员显示"
      }
    ],
    "goalOptions": [
      {
        "id": "project",
        "label": "创建项目并完成交付",
        "hint": "按客户、供应商、项目、质检和财务顺序学习"
      },
      {
        "id": "customer",
        "label": "管理客户与供应商",
        "hint": "适合客户、供应商运营"
      },
      {
        "id": "quality",
        "label": "排查记录与质量",
        "hint": "适合质控、项目复盘"
      },
      {
        "id": "finance",
        "label": "理解财务与结算",
        "hint": "适合财务、业务负责人"
      },
      {
        "id": "admin",
        "label": "配置团队与系统",
        "hint": "适合管理员"
      },
      {
        "id": "station",
        "label": "运营调查站",
        "hint": "适合会员与样本运营"
      }
    ],
    "experienceOptions": [
      {
        "id": "new",
        "label": "第一次使用此类系统",
        "hint": "先建立业务认知，再进入完整目标路径",
        "recommended": true
      },
      {
        "id": "similar",
        "label": "用过相似的调查平台",
        "hint": "保留系统差异和关键操作，合并基础说明"
      },
      {
        "id": "expert",
        "label": "我已熟悉业务流程",
        "hint": "跳过基础导览，只看所选目标的检查清单"
      }
    ],
    "taskOrder": [
      "interface-tour",
      "customer-management",
      "supplier-setup",
      "cooperation-resources",
      "project-create",
      "records-quality",
      "finance-overview",
      "station-overview",
      "station-members",
      "station-settings",
      "organization-permissions",
      "system-config"
    ],
    "tasks": [
      {
        "id": "interface-tour",
        "group": "essential",
        "title": "认识企业版工作台",
        "description": "了解业务导航、全局搜索、消息、账号、版本与快捷入口。",
        "estimate": "约 60 秒",
        "goals": [
          "project",
          "customer",
          "quality",
          "finance",
          "admin",
          "station"
        ],
        "permission": "",
        "permissionFallback": "",
        "steps": [
          {
            "id": "top-nav",
            "target": "[data-guide-id=\"top-nav\"]",
            "mobileTarget": "",
            "title": "先理解系统如何运转",
            "text": "典型流程是：首先确认客户或供应商的信息档案 → 创建客户和供应商 →创建项目 → 创建角色、部门、员工、提成规则 → 指定分配项目→分配供应商会员填写问卷。组织和配置提供权限并设置默认规则，调查站负责会员与样本运营。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "side-nav",
            "target": "[data-guide-id=\"side-nav\"]",
            "mobileTarget": "",
            "title": "当前模块的侧边导航",
            "text": "侧边栏只展示当前业务下的页面。以后进入项目、财务或调查站时，都可以先从这里判断自己所在的位置。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "global-search",
            "target": "[data-guide-id=\"global-search\"]",
            "mobileTarget": "",
            "title": "全局搜索",
            "text": "不确定功能在哪里时，可以按功能、帮助或数据关键字查找。搜索不会修改业务数据。",
            "interaction": "simulate",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "notifications",
            "target": "[data-guide-id=\"notifications\"]",
            "mobileTarget": "",
            "title": "消息与待办",
            "text": "项目提醒、合作结果和系统消息会从这里进入。优先处理未读和与当前项目相关的待办。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "personal-menu",
            "target": "[data-guide-id=\"personal-menu\"]",
            "mobileTarget": "",
            "title": "个人中心与教程入口",
            "text": "这里可以进入个人设置、更新日志、新手引导与教程和安全退出。关闭右下角入口后，也能从这里重新打开。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "plan-card",
            "target": "[data-guide-id=\"plan-card\"]",
            "mobileTarget": "",
            "title": "企业版与有效期",
            "text": "左下角显示当前版本和到期时间。企业版拥有完整功能，但最终仍以当前账号的角色权限为准。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "quick-actions",
            "target": "[data-guide-id=\"quick-actions\"]",
            "mobileTarget": "",
            "title": "四个快捷入口",
            "text": "这四个快熟点击入口用于快速进入新增项目、员工管理、个人官网、平台官网，是快速导航捷径，不会替代正式配置流程。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          }
        ]
      },
      {
        "id": "project-create",
        "group": "role",
        "title": "项目创建与发布前检查",
        "description": "认识项目依赖、主体设置、资质配额、风控和发布前核对；不会创建真实项目。",
        "estimate": "约 5 分钟",
        "goals": [
          "project"
        ],
        "permission": "project.view",
        "permissionFallback": "",
        "steps": [
          {
            "id": "project-filters",
            "target": "[data-guide-id=\"project-filters\"]",
            "mobileTarget": "",
            "title": "先认识项目筛选",
            "text": "可以按项目、客户、供应商、状态和时间缩小范围。日常查找优先使用项目ID或名称，避免在大量项目中逐页查找。",
            "interaction": "simulate",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "project-table",
            "target": "[data-guide-id=\"project-table\"]",
            "mobileTarget": "",
            "title": "项目状态与行操作",
            "text": "列表展示项目主体、状态、价格、预计指标和更新时间。上架、下架、分配及删除都可能改变真实业务状态，本教程不会代替点击。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "project-new",
            "target": "[data-guide-id=\"project-new\"]",
            "mobileTarget": "",
            "title": "打开新增项目",
            "text": "新增项目是企业版的核心入口。点击后只打开配置抽屉，不会自动填写、保存、上架或外发项目。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "project-drawer",
            "target": "[data-guide-id=\"project-tabs\"]",
            "mobileTarget": "[data-guide-id=\"project-drawer-summary\"]",
            "title": "创建前先准备必要资料",
            "text": "先准备客户归属、国家与币种、CPI、LOI、IR、项目URL和样本规则。资料齐全后，再按主体设置 → 资质与配额 → 风险控制完成检查。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "小屏会压缩三阶段页签，实际配置建议使用桌面端；移动端教程只说明结构。",
            "before": {
              "click": "[data-guide-id=\"project-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"project-drawer\"]",
              "tab": "[data-guide-id=\"project-tab-base\"]",
              "snapshot": "[data-guide-id=\"project-drawer\"]",
              "close": []
            }
          },
          {
            "id": "project-identity",
            "target": "[data-guide-id=\"project-base-identity\"]",
            "mobileTarget": "",
            "title": "项目身份与客户归属",
            "text": "项目名称称用于团队识别，项目标识用于系统追踪；客户决定项目的来源、需求、结算与部分规则来源，国家和币种要与实际交付保持一致。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"project-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"project-drawer\"]",
              "tab": "[data-guide-id=\"project-tab-base\"]",
              "snapshot": "[data-guide-id=\"project-drawer\"]",
              "close": []
            }
          },
          {
            "id": "project-commercial",
            "target": "[data-guide-id=\"project-base-commercial\"]",
            "mobileTarget": "",
            "title": "价格、状态与供应商",
            "text": "核对付款规则、所分配的供应商，并理解项目来源是不是 B2B、是否激活、项目置顶和路由检查开关。开关只讲含义，不由教程切换。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"project-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"project-drawer\"]",
              "tab": "[data-guide-id=\"project-tab-base\"]",
              "snapshot": "[data-guide-id=\"project-drawer\"]",
              "close": []
            }
          },
          {
            "id": "project-metrics",
            "target": "[data-guide-id=\"project-base-metrics\"]",
            "mobileTarget": "",
            "title": "配额、LOI、IR与项目URL",
            "text": "LOI是预计答题时长，IR是预计符合率；项目URL中的[uid]用于传递受访者标识。保存前应核对占位符和测试跳转。",
            "interaction": "",
            "readOnly": false,
            "risk": "external-link",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"project-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"project-drawer\"]",
              "tab": "[data-guide-id=\"project-tab-base\"]",
              "snapshot": "[data-guide-id=\"project-drawer\"]",
              "close": []
            }
          },
          {
            "id": "project-supplement",
            "target": "[data-guide-id=\"project-base-supplement\"]",
            "mobileTarget": "",
            "title": "备注、附件与项目说明",
            "text": "备注用于内部补充，附件承载需求资料，项目说明用于更完整地传达交付要求。上传前应确认文件不含无关敏感信息。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"project-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"project-drawer\"]",
              "tab": "[data-guide-id=\"project-tab-base\"]",
              "snapshot": "[data-guide-id=\"project-drawer\"]",
              "close": []
            }
          },
          {
            "id": "project-quota-tab",
            "target": "[data-guide-id=\"project-tab-quota\"]",
            "mobileTarget": "",
            "title": "进入资质与配额",
            "text": "这一页决定哪些设备和目标人群可以进入，以及各类样本的可用数量。教程会自动切换页签，但不会改变任何配额。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"project-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"project-drawer\"]",
              "tab": "[data-guide-id=\"project-tab-quota\"]",
              "snapshot": "[data-guide-id=\"project-drawer\"]",
              "close": []
            }
          },
          {
            "id": "project-quota-device",
            "target": "[data-guide-id=\"project-quota-device\"]",
            "mobileTarget": "",
            "title": "设备与分设备配额",
            "text": "分别理解桌面端、移动端和平板的允许状态及配额。总配额和分设备配额需要一致，避免流量已经进入但没有可用配额。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"project-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"project-drawer\"]",
              "tab": "[data-guide-id=\"project-tab-quota\"]",
              "snapshot": "[data-guide-id=\"project-drawer\"]",
              "close": []
            }
          },
          {
            "id": "project-quota-mutex",
            "target": "[data-guide-id=\"project-quota-mutex\"]",
            "mobileTarget": "",
            "title": "项目互斥规则",
            "text": "互斥用于阻止已参加指定项目的人再次进入当前项目。配置前应核对互斥项目范围，避免误伤正常样本。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"project-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"project-drawer\"]",
              "tab": "[data-guide-id=\"project-tab-quota\"]",
              "snapshot": "[data-guide-id=\"project-drawer\"]",
              "close": []
            }
          },
          {
            "id": "project-quota-screener",
            "target": "[data-guide-id=\"project-quota-screener\"]",
            "mobileTarget": "",
            "title": "前置筛选与当前答案",
            "text": "前置筛选用于在进入正式问卷前判断条件，当前答案配置用于保持规则一致。它们应与客户问卷逻辑共同核对。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"project-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"project-drawer\"]",
              "tab": "[data-guide-id=\"project-tab-quota\"]",
              "snapshot": "[data-guide-id=\"project-drawer\"]",
              "close": []
            }
          },
          {
            "id": "project-risk-tab",
            "target": "[data-guide-id=\"project-tab-risk\"]",
            "mobileTarget": "",
            "title": "进入风险控制",
            "text": "风险控制用于限制异常参与、设备、IP和质量风险。教程只讲解，不会开启、关闭或提交规则。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"project-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"project-drawer\"]",
              "tab": "[data-guide-id=\"project-tab-risk\"]",
              "snapshot": "[data-guide-id=\"project-drawer\"]",
              "close": []
            }
          },
          {
            "id": "project-risk-internal",
            "target": "[data-guide-id=\"project-risk-internal\"]",
            "mobileTarget": "",
            "title": "内部检测",
            "text": "内部检测用于应用平台自身的风险判断。启用前要确认它与客户级规则、第三方安检规则之间的继承关系。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"project-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"project-drawer\"]",
              "tab": "[data-guide-id=\"project-tab-risk\"]",
              "snapshot": "[data-guide-id=\"project-drawer\"]",
              "close": []
            }
          },
          {
            "id": "project-risk-hourly",
            "target": "[data-guide-id=\"project-risk-hourly\"]",
            "mobileTarget": "",
            "title": "每小时进入与完成限制",
            "text": "小时级限制用于控制流量速度和异常峰值。设置过低会影响交付，设置过高可能放大质量风险，应结合样本计划调整。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"project-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"project-drawer\"]",
              "tab": "[data-guide-id=\"project-tab-risk\"]",
              "snapshot": "[data-guide-id=\"project-drawer\"]",
              "close": []
            }
          },
          {
            "id": "project-risk-security",
            "target": "[data-guide-id=\"project-risk-security\"]",
            "mobileTarget": "",
            "title": "完成发布前检查，不等于已保存",
            "text": "你已认识项目配置和安检继承关系，但当前项目尚未保存。真正建草稿时，请主动保存；上线前还要测试URL、配额和风控规则。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"project-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"project-drawer\"]",
              "tab": "[data-guide-id=\"project-tab-risk\"]",
              "snapshot": "[data-guide-id=\"project-drawer\"]",
              "close": []
            }
          }
        ]
      },
      {
        "id": "customer-management",
        "group": "role",
        "title": "客户管理",
        "description": "覆盖客户列表、分析、新增抽屉、风险、回调与发票模板。",
        "estimate": "约 5 分钟",
        "goals": [
          "customer"
        ],
        "permission": "partner.view",
        "permissionFallback": "",
        "steps": [
          {
            "id": "customer-filters",
            "target": "[data-guide-id=\"customer-filters\"]",
            "mobileTarget": "",
            "title": "客户筛选与状态范围",
            "text": "按客户ID、名称、类型、来源和启用状态缩小范围。列表通用的分页、重置只在这里说明一次。",
            "interaction": "simulate",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "customer-table",
            "target": "[data-guide-id=\"customer-table\"]",
            "mobileTarget": "",
            "title": "客户列表与行操作",
            "text": "重点查看客户名称、简称、账期、分配模式和状态。编辑、删除、状态开关和API客户项目入口都会影响真实业务。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "customer-analysis",
            "target": "[data-guide-id=\"customer-analysis\"]",
            "mobileTarget": "",
            "title": "客户分析入口",
            "text": "客户分析用于查看项目上线、营业额、参与、完成、审核、发票概览和供应商排行，适合复盘客户质量与贡献。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"customer-analysis-open\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"customer-analysis\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"customer-analysis\"]",
              "close": []
            }
          },
          {
            "id": "customer-new",
            "target": "[data-guide-id=\"customer-new\"]",
            "mobileTarget": "",
            "title": "新增客户入口",
            "text": "客户档案承载项目来源、付款、分配、风控、回调和发票设置。点击只打开抽屉，不会提交数据。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": {
              "close": [
                "[data-guide-id=\"customer-analysis\"]"
              ],
              "waitFor": "[data-guide-id=\"customer-new\"]"
            }
          },
          {
            "id": "customer-tabs",
            "target": "[data-guide-id=\"customer-tabs\"]",
            "mobileTarget": "",
            "title": "客户配置结构",
            "text": "抽屉包括基本配置、风险控制、安检配置、回调与重定向、发票模板五个部分。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"customer-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"customer-drawer\"]",
              "tab": "[data-guide-id=\"customer-tab-base\"]",
              "snapshot": "[data-guide-id=\"customer-drawer\"]",
              "close": []
            }
          },
          {
            "id": "customer-identity",
            "target": "[data-guide-id=\"customer-base-identity\"]",
            "mobileTarget": "",
            "title": "客户主体与联系方式",
            "text": "核对客户名称、简称、公司、联系人、手机和邮箱。名称应稳定，联系方式应使用业务联系人而非临时测试信息。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"customer-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"customer-drawer\"]",
              "tab": "[data-guide-id=\"customer-tab-base\"]",
              "snapshot": "[data-guide-id=\"customer-drawer\"]",
              "close": []
            }
          },
          {
            "id": "customer-settlement",
            "target": "[data-guide-id=\"customer-base-settlement\"]",
            "mobileTarget": "",
            "title": "结算周期、币种与付款规则",
            "text": "这些字段会影响项目报价、账期和发票，应与合同约定保持一致。教程不会切换付款规则或保存。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"customer-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"customer-drawer\"]",
              "tab": "[data-guide-id=\"customer-tab-base\"]",
              "snapshot": "[data-guide-id=\"customer-drawer\"]",
              "close": []
            }
          },
          {
            "id": "customer-assignment",
            "target": "[data-guide-id=\"customer-base-assignment\"]",
            "mobileTarget": "",
            "title": "客户分配与业务开关",
            "text": "可多种选择、可按照自己指定的部门或自己旗下的多个部门轮流做该客户的项目，或创建者分配、不设置等；返点、前置筛选、API 客户和状态开关应由有权限人员确认。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"customer-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"customer-drawer\"]",
              "tab": "[data-guide-id=\"customer-tab-base\"]",
              "snapshot": "[data-guide-id=\"customer-drawer\"]",
              "close": []
            }
          },
          {
            "id": "customer-risk",
            "target": "[data-guide-id=\"customer-risk-panel\"]",
            "mobileTarget": "",
            "title": "客户级风险控制",
            "text": "客户级规则会影响其下项目。这里只说明继承边界，详细产品与规则在系统安检配置任务中学习。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"customer-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"customer-drawer\"]",
              "tab": "[data-guide-id=\"customer-tab-risk\"]",
              "snapshot": "[data-guide-id=\"customer-drawer\"]",
              "close": []
            }
          },
          {
            "id": "customer-security",
            "target": "[data-guide-id=\"customer-security-panel\"]",
            "mobileTarget": "",
            "title": "客户安检配置",
            "text": "安检用于接入第三方检测和安全策略。启停、产品和逻辑更改都可能影响全部关联项目。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"customer-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"customer-drawer\"]",
              "tab": "[data-guide-id=\"customer-tab-security\"]",
              "snapshot": "[data-guide-id=\"customer-drawer\"]",
              "close": []
            }
          },
          {
            "id": "customer-callback-front",
            "target": "[data-guide-id=\"customer-callback-front\"]",
            "mobileTarget": "",
            "title": "前端回调与重定向",
            "text": "前端回调决定完成、配额满、筛除和安全终止后的跳转。上线前必须用测试项目逐条验证。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"customer-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"customer-drawer\"]",
              "tab": "[data-guide-id=\"customer-tab-callback\"]",
              "snapshot": "[data-guide-id=\"customer-drawer\"]",
              "close": []
            }
          },
          {
            "id": "customer-callback-s2s",
            "target": "[data-guide-id=\"customer-callback-s2s\"]",
            "mobileTarget": "",
            "title": "S2S回调与参数映射",
            "text": "服务器回调用于系统间传递状态。需要核对URL、项目字段、UID和映射关系，教程不发送测试请求。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"customer-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"customer-drawer\"]",
              "tab": "[data-guide-id=\"customer-tab-callback\"]",
              "snapshot": "[data-guide-id=\"customer-drawer\"]",
              "close": []
            }
          },
          {
            "id": "customer-invoice",
            "target": "[data-guide-id=\"customer-invoice-panel\"]",
            "mobileTarget": "",
            "title": "完成客户建档前检查",
            "text": "你已认识客户建档所需的主体、结算和分配信息。风控、回调和发票可在客户建立后按需配置；当前没有创建或保存客户。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"customer-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"customer-drawer\"]",
              "tab": "[data-guide-id=\"customer-tab-invoice\"]",
              "snapshot": "[data-guide-id=\"customer-drawer\"]",
              "close": []
            }
          }
        ]
      },
      {
        "id": "supplier-setup",
        "group": "role",
        "title": "建立供应商档案",
        "description": "覆盖供应商列表、基本资料、项目控制、财务、回调与辅助页面。",
        "estimate": "约 6 分钟",
        "goals": [
          "customer"
        ],
        "permission": "supplier.view",
        "permissionFallback": "",
        "steps": [
          {
            "id": "supplier-filters",
            "target": "[data-guide-id=\"supplier-filters\"]",
            "mobileTarget": "",
            "title": "供应商筛选",
            "text": "可按供应商ID、名称、联系人、公司、等级、区域和状态定位供应商。",
            "interaction": "simulate",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "supplier-table",
            "target": "[data-guide-id=\"supplier-table\"]",
            "mobileTarget": "",
            "title": "列表中的经营信息",
            "text": "重点查看等级、区域、可用钱包、待审钱包、账期、B2B/B2C和启用状态。列表开关可能即时改变业务状态。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "supplier-new",
            "target": "[data-guide-id=\"supplier-new\"]",
            "mobileTarget": "",
            "title": "新增供应商入口",
            "text": "点击后打开供应商档案抽屉。教程只打开表单，不填写密码、不保存、不改变任何状态。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "supplier-tabs",
            "target": "[data-guide-id=\"supplier-tabs\"]",
            "mobileTarget": "",
            "title": "供应商配置顺序",
            "text": "先完成基本配置和项目控制，再核对财务信息，最后处理回调与重定向。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"supplier-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"supplier-drawer\"]",
              "tab": "[data-guide-id=\"supplier-tab-base\"]",
              "snapshot": "[data-guide-id=\"supplier-drawer\"]",
              "close": []
            }
          },
          {
            "id": "supplier-identity",
            "target": "[data-guide-id=\"supplier-base-identity\"]",
            "mobileTarget": "",
            "title": "账户与联系人",
            "text": "核对账户类型、名称、区域、电话、邮箱和联系人。密码属于敏感信息，演示和埋点均不得记录。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"supplier-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"supplier-drawer\"]",
              "tab": "[data-guide-id=\"supplier-tab-base\"]",
              "snapshot": "[data-guide-id=\"supplier-drawer\"]",
              "close": []
            }
          },
          {
            "id": "supplier-settlement",
            "target": "[data-guide-id=\"supplier-base-settlement\"]",
            "mobileTarget": "",
            "title": "等级、币种、财务类型与账期",
            "text": "这些字段决定成本、钱包和结算方式，应与合同保持一致。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"supplier-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"supplier-drawer\"]",
              "tab": "[data-guide-id=\"supplier-tab-base\"]",
              "snapshot": "[data-guide-id=\"supplier-drawer\"]",
              "close": []
            }
          },
          {
            "id": "supplier-control",
            "target": "[data-guide-id=\"supplier-base-control\"]",
            "mobileTarget": "",
            "title": "B2B、B2C和项目控制",
            "text": "B2B 与 B2C 代表不同业务类型；默认开放和仅指定决定供应商可以接收哪些地区的项目。教程不会切换开关。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"supplier-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"supplier-drawer\"]",
              "tab": "[data-guide-id=\"supplier-tab-base\"]",
              "snapshot": "[data-guide-id=\"supplier-drawer\"]",
              "close": []
            }
          },
          {
            "id": "supplier-regions",
            "target": "[data-guide-id=\"supplier-base-regions\"]",
            "mobileTarget": "",
            "title": "开放与禁用区域",
            "text": "通过左右选择区域决定供应商可承接范围。区域配置错误会造成无法分发或错误流量进入。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"supplier-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"supplier-drawer\"]",
              "tab": "[data-guide-id=\"supplier-tab-base\"]",
              "snapshot": "[data-guide-id=\"supplier-drawer\"]",
              "close": []
            }
          },
          {
            "id": "supplier-clients",
            "target": "[data-guide-id=\"supplier-base-clients\"]",
            "mobileTarget": "",
            "title": "开放与禁用客户",
            "text": "客户范围和区域范围共同决定供应商可接收的项目。调整前应确认现有合作边界。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"supplier-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"supplier-drawer\"]",
              "tab": "[data-guide-id=\"supplier-tab-base\"]",
              "snapshot": "[data-guide-id=\"supplier-drawer\"]",
              "close": []
            }
          },
          {
            "id": "supplier-finance-tab",
            "target": "[data-guide-id=\"supplier-tab-finance\"]",
            "mobileTarget": "",
            "title": "切换到财务信息",
            "text": "财务页用于维护收款方式、收款账号和账户姓名。请在基本资料和合作范围确认后进入，并按合同主体逐项核对。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"supplier-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"supplier-drawer\"]",
              "tab": "[data-guide-id=\"supplier-tab-finance\"]",
              "snapshot": "[data-guide-id=\"supplier-drawer\"]",
              "close": []
            }
          },
          {
            "id": "supplier-finance-account",
            "target": "[data-guide-id=\"supplier-finance-account\"]",
            "mobileTarget": "",
            "title": "收款资料",
            "text": "收款方式、账号和账户姓名应与合同主体一致。教程不读取、不复制、不提交真实收款账号。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"supplier-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"supplier-drawer\"]",
              "tab": "[data-guide-id=\"supplier-tab-finance\"]",
              "snapshot": "[data-guide-id=\"supplier-drawer\"]",
              "close": []
            }
          },
          {
            "id": "supplier-callback-tab",
            "target": "[data-guide-id=\"supplier-tab-callback\"]",
            "mobileTarget": "",
            "title": "切换到回调与重定向",
            "text": "回调用于同步完成、配额满、筛除和安全终止等状态。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"supplier-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"supplier-drawer\"]",
              "tab": "[data-guide-id=\"supplier-tab-callback\"]",
              "snapshot": "[data-guide-id=\"supplier-drawer\"]",
              "close": []
            }
          },
          {
            "id": "supplier-callback",
            "target": "[data-guide-id=\"supplier-callback-panel\"]",
            "mobileTarget": "",
            "title": "前端与S2S回调",
            "text": "分别核对前端跳转URL和服务器回调URL。上线前使用测试项目验证，本教程不会发送请求或保存。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"supplier-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"supplier-drawer\"]",
              "tab": "[data-guide-id=\"supplier-tab-callback\"]",
              "snapshot": "[data-guide-id=\"supplier-drawer\"]",
              "close": []
            }
          },
          {
            "id": "supplier-members",
            "target": "[data-guide-id=\"supplier-member-table\"]",
            "mobileTarget": "",
            "title": "子会员与UID映射",
            "text": "子会员列表用于关联供应商会员、本站会员和UID。会员资料可能包含敏感信息，导出和查看必须遵守权限。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "supplier-levels",
            "target": "[data-guide-id=\"supplier-level-table\"]",
            "mobileTarget": "",
            "title": "供应商等级",
            "text": "等级中的B2B和B2C价格比例会影响关联供应商，新增、编辑或删除前应确认影响范围。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "supplier-panel-book",
            "target": "[data-guide-id=\"supplier-panel-theme\"]",
            "mobileTarget": "",
            "title": "面板书与品牌展示",
            "text": "这里配置模板、品牌、颜色、字体和布局。保存主题、生成预览和下载只作介绍，不由教程执行。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          }
        ]
      },
      {
        "id": "cooperation-resources",
        "group": "role",
        "title": "管理合作资源",
        "description": "从对外资料、云资源筛选和合作申请开始，建立可持续维护的合作关系，并追踪积分与账单。",
        "estimate": "约 5 分钟",
        "goals": [
          "customer",
          "project"
        ],
        "permission": "partner.view",
        "permissionFallback": "",
        "steps": [
          {
            "id": "cooperation-overview",
            "target": ".coop-my-overview",
            "mobileTarget": "",
            "title": "先理解合作资源闭环",
            "text": "正确顺序是：完善对外资料 → 在云资源中筛选对象并核对详情 → 发起或处理合作申请 → 申请通过后维护合作关系 → 在积分和账单中追踪资源消耗。教程只讲解流程，不会自动申请、接受、拒绝、解锁或付款。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "cooperation-profile",
            "target": "[data-my-panel=\"profile\"]",
            "mobileTarget": "",
            "title": "先完善对外资料与开放范围",
            "text": "名称、简介、业务区域、联系信息和公开能力决定合作方看到的企业身份；云资源开放范围决定可发现的合作对象。请先核对真实性和可公开性，再由有权限人员保存，教程不会提交资料或切换开放状态。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-my-tab=\"profile\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-my-panel=\"profile\"]:not([hidden])",
              "snapshot": "[data-my-panel=\"profile\"]"
            }
          },
          {
            "id": "cooperation-supplier-market",
            "target": ".coop-market-card",
            "mobileTarget": "",
            "title": "筛选云供应商候选资源",
            "text": "先按地区、能力、评分和合作状态缩小范围，再比较项目承接、完成率、响应速度与合作评价。列表指标用于初筛，不能替代合同、交付能力和数据安全审核。",
            "interaction": "simulate",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "close": [
                "[data-coop-detail-layer]"
              ],
              "waitFor": ".coop-market-card"
            }
          },
          {
            "id": "cooperation-supplier-detail",
            "target": ".coop-detail-drawer",
            "mobileTarget": "",
            "title": "核对供应商详情再决定合作",
            "text": "详情中的企业资料、服务区域、交付指标、评价和历史表现需要交叉核对。解锁联系方式、发送消息或发起合作申请会产生真实业务影响，本教程只打开详情，不会执行这些操作。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-coop-detail]",
              "safeAction": "open-surface",
              "waitFor": "[data-coop-detail-layer][aria-hidden=\"false\"] .coop-detail-drawer",
              "snapshot": ".coop-detail-drawer"
            }
          },
          {
            "id": "cooperation-customer-market",
            "target": ".coop-market-card",
            "mobileTarget": "",
            "title": "筛选云客户合作机会",
            "text": "先按地区、行业、评分和合作状态筛选，再比较项目发布、结算表现、响应速度和合作评价。高需求量不等于低风险，仍需确认需求真实性、结算条件与交付边界。",
            "interaction": "simulate",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "close": [
                "[data-coop-detail-layer]"
              ],
              "waitFor": ".coop-market-card"
            }
          },
          {
            "id": "cooperation-customer-detail",
            "target": ".coop-detail-drawer",
            "mobileTarget": "",
            "title": "核对客户详情与合作条件",
            "text": "重点核对企业资料、项目机会、结算表现、评价和公开联系方式。解锁、发送消息或申请合作前，应确认负责人、合同主体和回款条件；教程只展示详情，不会提交任何申请。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-coop-detail]",
              "safeAction": "open-surface",
              "waitFor": "[data-coop-detail-layer][aria-hidden=\"false\"] .coop-detail-drawer",
              "snapshot": ".coop-detail-drawer"
            }
          },
          {
            "id": "cooperation-applications",
            "target": "[data-my-panel=\"sent\"]",
            "mobileTarget": "",
            "title": "按方向和状态处理合作申请",
            "text": "收到的申请用于判断是否接受外部合作，发出的申请用于追踪对方处理结果。先核对申请方、合作目的、负责人和当前状态；接受、拒绝、撤回或再次申请都必须由用户主动确认。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-my-tab=\"sent\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-my-panel=\"sent\"]:not([hidden])",
              "snapshot": "[data-my-panel=\"sent\"]"
            }
          },
          {
            "id": "cooperation-partners",
            "target": "[data-my-panel=\"partners\"]",
            "mobileTarget": "",
            "title": "申请通过后才进入合作关系",
            "text": "只有通过的合作申请才会形成正式合作关系。这里用于核对合作对象、合作状态和后续沟通入口；暂停或解除关系前，应先确认正在执行的项目、账务和双方负责人。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-my-tab=\"partners\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-my-panel=\"partners\"]:not([hidden])",
              "snapshot": "[data-my-panel=\"partners\"]"
            }
          },
          {
            "id": "cooperation-points",
            "target": "[data-my-panel=\"points\"]",
            "mobileTarget": "",
            "title": "用积分明细追踪资源消耗",
            "text": "积分通常与资料解锁、申请合作等动作相关。按时间、业务类型和 ID 来核对来源，出现异常时先回查对应合作对象和操作记录；点数每月月初自动刷新，教程不会消耗或调整积分。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-my-tab=\"points\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-my-panel=\"points\"]:not([hidden])",
              "snapshot": "[data-my-panel=\"points\"]"
            }
          },
          {
            "id": "cooperation-bills",
            "target": "[data-my-panel=\"bills\"]",
            "mobileTarget": "",
            "title": "最后核对合作账单",
            "text": "按账单周期、合作对象、币种、金额和状态核对费用，并与积分明细、合同及实际合作动作保持一致。支付、确认或争议处理会影响真实账务，必须由有权限人员复核，教程不会代为操作。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-my-tab=\"bills\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-my-panel=\"bills\"]:not([hidden])",
              "snapshot": "[data-my-panel=\"bills\"]"
            }
          }
        ]
      },
      {
        "id": "records-quality",
        "group": "role",
        "title": "排查调查记录与质量问题",
        "description": "用项目、点击ID、状态和时间定位问题并建立复盘路径。",
        "estimate": "约 2 分钟",
        "goals": [
          "quality",
          "project"
        ],
        "permission": "record.view",
        "permissionFallback": "",
        "steps": [
          {
            "id": "record-filter",
            "target": ".record-filter-card",
            "mobileTarget": "",
            "title": "先缩小查询范围",
            "text": "优先使用点击ID或项目ID精确查询；跨项目排查时再组合状态、供应商、区域和日期。",
            "interaction": "simulate",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "record-expand",
            "target": "[data-record-expand]",
            "mobileTarget": "",
            "title": "展开高级条件",
            "text": "高级条件适合质控排查。条件越多结果越少，无结果时应逐步减少条件。",
            "interaction": "simulate",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "record-table",
            "target": ".record-table-wrap",
            "mobileTarget": "",
            "title": "理解两类记录状态",
            "text": "记录状态表示平台处理结果，客户状态表示客户侧反馈；两者不一致时不能单独下结论。先核对项目、供应商和回调，再决定是否升级处理。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "record-export",
            "target": "[data-record-export]",
            "mobileTarget": "",
            "title": "导出前先筛选",
            "text": "导出可能包含业务数据。请确认范围和权限，教程不会发起导出。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          }
        ]
      },
      {
        "id": "finance-overview",
        "group": "role",
        "title": "认识财务关系与对账入口",
        "description": "跨页认识供应商财务日志、供应商账单和客户发票。",
        "estimate": "约 4 分钟",
        "goals": [
          "finance"
        ],
        "permission": "finance.view",
        "permissionFallback": "",
        "steps": [
          {
            "id": "finance-log-filters",
            "target": "[data-guide-id=\"finance-supplier-log-filters\"]",
            "mobileTarget": "",
            "title": "从财务日志追溯资金变化",
            "text": "完整链路是质检与项目结算产生变化，财务日志记录原因，供应商账单汇总结算，客户发票记录应收。先按记录、供应商、钱包或项目定位。",
            "interaction": "simulate",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "finance-log-table",
            "target": "[data-guide-id=\"finance-supplier-log-table\"]",
            "mobileTarget": "",
            "title": "变动前、变动值与变动后",
            "text": "三项金额必须连续一致，再结合钱包、项目、记录、原因和备注判断资金为什么变化。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "finance-log-safety",
            "target": "[data-guide-id=\"finance-supplier-log-table\"]",
            "mobileTarget": "",
            "title": "日志用于追溯，不直接改账",
            "text": "日志是审计依据。员工财务日志采用相同模型，只是主体换成员工，因此不重复完整教学。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "finance-bill-filters",
            "target": "[data-guide-id=\"finance-supplier-bill-filters\"]",
            "mobileTarget": "",
            "title": "供应商账单筛选",
            "text": "按账单ID、供应商、状态和账期核对，避免跨账期或跨主体处理。",
            "interaction": "simulate",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "finance-bill-table",
            "target": "[data-guide-id=\"finance-supplier-bill-table\"]",
            "mobileTarget": "",
            "title": "账期、金额、手续费与实付",
            "text": "先核对供应商、币种、账期、账单金额、手续费、实付金额和状态。本步骤仅查看，不要勾选账单或使用行内操作。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "finance-bill-new",
            "target": "[data-guide-id=\"finance-supplier-bill-new\"]",
            "mobileTarget": "",
            "title": "新增结算的含义",
            "text": "新增结算可以针对全部或指定供应商，并设置最低结算金额。提交会生成真实结算，本教程只解释入口。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "finance-bill-risk",
            "target": "[data-guide-id=\"finance-supplier-bill-risk-actions\"]",
            "mobileTarget": "",
            "title": "支付、拒绝和批量操作",
            "text": "支付、批量支付、拒绝、批量拒绝、编辑和已收发票都会改变财务状态，必须由有权限人员复核。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "finance-invoice-filters",
            "target": "[data-guide-id=\"finance-customer-invoice-filters\"]",
            "mobileTarget": "",
            "title": "客户发票筛选",
            "text": "按发票ID、编号、客户、状态和开票日期定位应收记录。",
            "interaction": "simulate",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "finance-invoice-table",
            "target": "[data-guide-id=\"finance-customer-invoice-table\"]",
            "mobileTarget": "",
            "title": "金额、已收款与状态",
            "text": "先核对客户、发票编号、金额、已收款、手续费、开票人、状态和日期。本步骤仅查看，不执行编辑、作废或下载。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "finance-invoice-risk",
            "target": "[data-guide-id=\"finance-customer-invoice-risk-actions\"]",
            "mobileTarget": "",
            "title": "开票、作废与明细下载",
            "text": "新增、编辑、作废、导出和下载明细都可能涉及真实财务数据。完成本教程只表示理解关系，不会执行任何资金动作。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          }
        ]
      },
      {
        "id": "station-overview",
        "group": "station",
        "title": "认识调查站运营闭环",
        "description": "从数据看板进入会员、项目、调度、记录和财务运营。",
        "estimate": "约 2 分钟",
        "goals": [
          "station"
        ],
        "permission": "survey_station.view",
        "permissionFallback": "",
        "steps": [
          {
            "id": "station-nav",
            "target": ".survey-station-menu",
            "mobileTarget": "",
            "title": "调查站运营闭环",
            "text": "调查站的工作顺序是：维护会员、会员组和等级 → 配置站点规则 → 调度项目 → 查看记录与质量 → 从财务日志追溯结算。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "station-kpis",
            "target": "[data-guide-id=\"station-kpis\"]",
            "mobileTarget": "",
            "title": "参与、完成、收入与拒绝",
            "text": "结合多个指标判断运营健康度，不要只看参与量或单一收入。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "station-wallets",
            "target": "[data-guide-id=\"station-wallets\"]",
            "mobileTarget": "",
            "title": "可用钱包与待审核钱包",
            "text": "钱包反映运营主体的资金状态，具体变动要回到财务日志追溯。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "station-range",
            "target": "[data-guide-id=\"station-range\"]",
            "mobileTarget": "",
            "title": "统一统计口径",
            "text": "比较趋势前先统一当日、本周、本月或自定义日期口径，刷新只更新当前范围。",
            "interaction": "simulate",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "station-analysis",
            "target": "[data-guide-id=\"station-analysis-charts\"]",
            "mobileTarget": "",
            "title": "数据分析与排行",
            "text": "数据分析用于查看趋势、类型分布和排行。确认时间口径后再比较项目或会员表现。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          }
        ]
      },
      {
        "id": "station-members",
        "group": "station",
        "title": "调查站会员运营",
        "description": "认识会员、会员组、会员等级及新增抽屉。",
        "estimate": "约 4 分钟",
        "goals": [
          "station"
        ],
        "permission": "survey_station.member.view",
        "permissionFallback": "",
        "steps": [
          {
            "id": "station-member-filters",
            "target": "[data-guide-id=\"station-members-filters\"]",
            "mobileTarget": "",
            "title": "会员筛选",
            "text": "按会员ID、等级、会员组和状态定位会员。个人资料只在有权限且有业务需要时查看。",
            "interaction": "simulate",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "station-member-table",
            "target": "[data-guide-id=\"station-members-table\"]",
            "mobileTarget": "",
            "title": "会员列表",
            "text": "重点查看会员身份、等级、会员组、钱包、区域以及B2B/B2C状态。本步骤只查看，不切换状态、不编辑、不删除。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "station-member-new",
            "target": "[data-guide-id=\"station-members-new\"]",
            "mobileTarget": "",
            "title": "新增会员入口",
            "text": "点击只打开会员抽屉，不会创建账号或发送密码。",
            "interaction": "",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "station-member-drawer",
            "target": "[data-guide-id=\"station-members-drawer\"]",
            "mobileTarget": "",
            "title": "会员基础资料",
            "text": "核对账号、联系方式、地区、等级和状态。密码及个人信息不得写入教程日志。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"station-members-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"station-members-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"station-members-drawer\"]",
              "close": []
            }
          },
          {
            "id": "station-member-assignment",
            "target": "[data-guide-id=\"station-members-control\"]",
            "mobileTarget": "",
            "title": "会员分组与范围",
            "text": "通过等级、会员组和允许范围控制会员运营路径。保存前应确认分组结果。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"station-members-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"station-members-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"station-members-drawer\"]",
              "close": []
            }
          },
          {
            "id": "station-group-table",
            "target": "[data-guide-id=\"station-member-groups-table\"]",
            "mobileTarget": "",
            "title": "先准备会员组",
            "text": "会员组用于批量组织会员和运营策略。新增会员前先确认组名、负责人和状态；本步骤不编辑或删除。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "station-group-drawer",
            "target": "[data-guide-id=\"station-member-groups-drawer\"]",
            "mobileTarget": "",
            "title": "新增会员组",
            "text": "介绍组名、负责人和相关设置；教程只打开抽屉，不保存或删除会员组。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"station-member-groups-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"station-member-groups-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"station-member-groups-drawer\"]",
              "close": []
            }
          },
          {
            "id": "station-level-table",
            "target": "[data-guide-id=\"station-member-levels-table\"]",
            "mobileTarget": "",
            "title": "再准备会员等级",
            "text": "会员等级承载 B2B/B2C 项目价格比例，价格比例调整会影响结算；本步骤不编辑或删除。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "station-level-drawer",
            "target": "[data-guide-id=\"station-member-levels-drawer\"]",
            "mobileTarget": "",
            "title": "新增会员等级",
            "text": "介绍等级名称和价格比例。教程不保存、不删除，也不会修改已有会员。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"station-member-levels-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"station-member-levels-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"station-member-levels-drawer\"]",
              "close": []
            }
          }
        ]
      },
      {
        "id": "station-settings",
        "group": "station",
        "title": "站点设置与项目调度",
        "description": "认识基础配置、访问验证、会员结算、协议管理和项目调度。",
        "estimate": "约 4 分钟",
        "goals": [
          "station"
        ],
        "permission": "survey_station.settings.view",
        "permissionFallback": "",
        "steps": [
          {
            "id": "station-settings-tabs",
            "target": "[data-guide-id=\"station-settings-tabs\"]",
            "mobileTarget": "",
            "title": "基础配置入口",
            "text": "站点设置集中管理会员进入站点前后的基础规则。教程会依次说明各区域，不会替你保存或删除数据。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "station-settings-access",
            "target": "[data-guide-id=\"station-settings-access\"]",
            "mobileTarget": "",
            "title": "访问、注册与验证",
            "text": "注册开关和验证方式决定会员如何进入站点。正式使用前应确认审核方式，以及手机、邮箱等验证链路。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "station-settings-display",
            "target": "[data-guide-id=\"station-settings-display\"]",
            "mobileTarget": "",
            "title": "前台显示与协议开关",
            "text": "显示描述、项目别名、CPI 和用户协议开关决定会员端可见内容，调整前应核对站点运营规则。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "station-settings-member",
            "target": "[data-guide-id=\"station-settings-member-settlement\"]",
            "mobileTarget": "",
            "title": "会员与结算规则",
            "text": "默认小组和等级决定新会员归属，最低结算金额是结算门槛；调查限价和运行模式会影响会员可接任务范围。修改前须按运营规则复核。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "station-settings-protocol",
            "target": "[data-guide-id=\"station-settings-protocol\"]",
            "mobileTarget": "",
            "title": "协议管理",
            "text": "上传前核对语言、协议名称、文件版本和生效范围；删除可能导致对应语言的协议不可用。教程不执行上传、下载或删除。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "station-settings-actions",
            "target": "[data-guide-id=\"station-settings-actions\"]",
            "mobileTarget": "",
            "title": "确认配置变更",
            "text": "“确认”用于保存当前基础配置，“取消”用于放弃本次调整。教程不会点击这两个按钮。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": ""
          },
          {
            "id": "station-schedule-filters",
            "target": "[data-guide-id=\"station-schedule-filters\"]",
            "mobileTarget": "",
            "title": "项目调度筛选",
            "text": "按会员、会员组和调度状态缩小范围，先确认目标对象再安排任务。",
            "interaction": "simulate",
            "readOnly": false,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "station-schedule-table",
            "target": "[data-guide-id=\"station-schedule-table\"]",
            "mobileTarget": "",
            "title": "调度列表与状态",
            "text": "列表用于核对项目、对象、类型、数量和状态。批量删除属于高风险操作。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "station-schedule-new",
            "target": "[data-guide-id=\"station-schedule-new\"]",
            "mobileTarget": "",
            "title": "新增调度",
            "text": "新增调度会把项目流量分配给真实会员或会员组。提交前核对项目、调度对象、类型和数量；教程只介绍入口，不提交。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          }
        ]
      },
      {
        "id": "organization-permissions",
        "group": "admin",
        "title": "配置团队与权限",
        "description": "按部门层级、角色权限、员工授权和提成规则的正确顺序完成团队配置。",
        "estimate": "约 9 分钟",
        "goals": [
          "admin"
        ],
        "permission": "admin.view",
        "permissionFallback": "[href*='organization-'], [data-nav='组织']",
        "steps": [
          {
            "id": "org-department-filters",
            "target": "[data-guide-id=\"organization-department-filters\"]",
            "mobileTarget": "",
            "title": "先按“部门 → 角色 → 员工”配置",
            "text": "部门确定组织归属和管理边界，角色复用菜单、操作与数据权限，员工最后绑定部门和角色。先检查已有部门，避免重复建档或把员工挂到错误层级。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "org-department-table",
            "target": "[data-guide-id=\"organization-department-table\"]",
            "mobileTarget": "",
            "title": "先从层级、主管和人数判断影响范围",
            "text": "重点核对上级部门、主管、员工数和状态。调整上级关系会改变组织层级；删除或停用前必须先确认下级部门、在岗员工和业务负责人。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "org-department-drawer",
            "target": "[data-guide-id=\"organization-department-drawer\"]",
            "mobileTarget": "",
            "title": "部门基本信息决定归属关系",
            "text": "新增时先填写稳定、可识别的部门名称，再选择正确的上级部门。层级选错会影响员工归属、主管管理范围和后续权限排查；教程只打开抽屉，不保存。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"organization-department-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-department-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"organization-department-drawer\"]",
              "close": []
            }
          },
          {
            "id": "org-department-permission",
            "target": "[data-guide-id=\"organization-department-permissions\"]",
            "mobileTarget": "",
            "title": "部门权限只授予团队必需能力",
            "text": "部门权限用于限定该组织单元的基础业务边界，不等同于员工最终权限。先按部门职责选择最小范围，再由角色补充岗位所需菜单和操作能力。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"organization-department-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-department-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"organization-department-drawer\"]",
              "close": []
            }
          },
          {
            "id": "org-department-manager",
            "target": "[data-guide-id=\"organization-department-managers\"]",
            "mobileTarget": "",
            "title": "主管承担管理职责，不代替角色授权",
            "text": "主管用于明确部门负责人和管理责任，但成为主管不代表自动拥有全部菜单、操作或数据权限。保存前分别核对主管人选、角色和数据范围。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"organization-department-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-department-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"organization-department-drawer\"]",
              "close": []
            }
          },
          {
            "id": "org-role-table",
            "target": "[data-guide-id=\"organization-role-table\"]",
            "mobileTarget": "",
            "title": "角色代表岗位职责，不代表组织归属",
            "text": "部门回答“员工属于哪里”，角色回答“员工能做什么”。先复用职责相同的现有角色，避免创建名称不同但权限重复的角色；本步骤不编辑或删除。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "org-role-dialog",
            "target": "[data-guide-id=\"organization-role-new-dialog\"]",
            "mobileTarget": "",
            "title": "按岗位职责命名角色",
            "text": "角色名称应能直接反映岗位职责，例如项目运营、财务审核或质量管理员。不要用员工姓名命名长期角色；教程只打开弹窗，不创建角色。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"organization-role-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-role-new-dialog\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"organization-role-new-dialog\"]",
              "close": []
            }
          },
          {
            "id": "org-role-menu",
            "target": "[data-guide-id=\"organization-role-menu-panel\"]",
            "mobileTarget": "",
            "title": "菜单权限决定能否进入页面",
            "text": "先为该角色保留完成工作必需的页面入口权限。未授权的页面该角色看不到未授权页面；该操作旨在为不同的职位设置指定的权限大小。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "close": [
                "[data-guide-id=\"organization-role-new-dialog\"]"
              ],
              "click": "[data-role-table-body] [data-role-menu]:not([disabled])",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-role-menu-drawer\"]",
              "snapshot": "[data-guide-id=\"organization-role-menu-drawer\"]"
            }
          },
          {
            "id": "org-role-permissions",
            "target": "[data-guide-id=\"organization-role-permission-panel\"]",
            "mobileTarget": "",
            "title": "操作权限与数据范围必须分别核对",
            "text": "操作权限决定可新增、编辑、审核、删除或导出数据等；数据权限决定能看到哪些客户、供应商、项目或团队数据。两者缺一都可能造成工作受阻或越权。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "close": [
                "[data-guide-id=\"organization-role-menu-drawer\"]"
              ],
              "click": "[data-role-table-body] [data-role-permission]:not([disabled])",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-role-permission-drawer\"]",
              "snapshot": "[data-guide-id=\"organization-role-permission-drawer\"]"
            }
          },
          {
            "id": "org-role-diagnostics",
            "target": "[data-guide-id=\"organization-role-permission-drawer\"]",
            "mobileTarget": "",
            "title": "按固定顺序排查权限异常",
            "text": "员工看不到功能时，依次检查账号状态、所属部门、绑定角色、菜单入口、操作权限和数据范围。不要直接授予全部权限来绕过问题，保存前还要复核已选数量。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "close": [
                "[data-guide-id=\"organization-role-menu-drawer\"]"
              ],
              "click": "[data-role-table-body] [data-role-permission]:not([disabled])",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-role-permission-drawer\"]",
              "snapshot": "[data-guide-id=\"organization-role-permission-drawer\"]"
            }
          },
          {
            "id": "org-employee-filters",
            "target": "[data-guide-id=\"organization-employee-filters\"]",
            "mobileTarget": "",
            "title": "创建前先检查账号、部门、角色和状态",
            "text": "通过员工ID、账号、姓名、部门、角色和状态确认账号是否已存在。重复账号会增加授权、禁用和财务归属的排查成本，本步骤只查询不修改。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "org-employee-table",
            "target": "[data-guide-id=\"organization-employee-table\"]",
            "mobileTarget": "",
            "title": "员工列表是授权结果的核对入口",
            "text": "列表同时展示账号、联系方式、钱包、部门、角色和状态。员工无法登录先查状态；能登录但功能异常，再按部门、角色、菜单、操作和数据范围逐层排查。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "org-employee-account",
            "target": "[data-guide-id=\"organization-employee-drawer\"]",
            "mobileTarget": "",
            "title": "先建立可追溯的员工登录身份",
            "text": "账号、姓名和联系方式用于识别真实操作人，初始登录信息应通过安全渠道交付。不要使用共用账号或临时测试身份承载正式业务；教程不创建员工。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"organization-employee-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-employee-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"organization-employee-drawer\"]",
              "close": []
            }
          },
          {
            "id": "org-employee-assignment",
            "target": "[data-guide-id=\"organization-employee-form\"]",
            "mobileTarget": "",
            "title": "部门确定归属，角色决定工作能力",
            "text": "先选择员工实际所属部门，再分配与岗位职责匹配的角色。调岗时必须同步检查旧角色是否应移除，避免权限叠加；禁用账号会立即影响登录。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"organization-employee-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-employee-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"organization-employee-drawer\"]",
              "close": []
            }
          },
          {
            "id": "org-commission-table",
            "target": "[data-guide-id=\"organization-commission-table\"]",
            "mobileTarget": "",
            "title": "提成规则会影响真实收入计算",
            "text": "先检查现有规则的适用员工、条件、对象、比例、状态和优先关系。删除前必须确认是否会影响该指定比例的人员与结算周期。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "org-commission-employees",
            "target": "[data-guide-id=\"organization-commission-employees\"]",
            "mobileTarget": "",
            "title": "先限定提成适用员工",
            "text": "先选择真正参与该业务的员工，再配置计算条件。人员范围过大会把不相关员工纳入计算，范围过小则可能漏算；教程只展示结构，不保存。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"organization-commission-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-commission-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"organization-commission-drawer\"]",
              "close": []
            }
          },
          {
            "id": "org-commission-conditions",
            "target": "[data-guide-id=\"organization-commission-conditions\"]",
            "mobileTarget": "",
            "title": "条件、对象、比例和发放节点共同生效",
            "text": "明确提成基于哪个业务对象、满足什么条件、按什么比例计算以及何时发放。任何一项口径不清都可能造成结算争议，应与正式制度保持一致。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"organization-commission-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-commission-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"organization-commission-drawer\"]",
              "close": []
            }
          },
          {
            "id": "org-commission-preview",
            "target": "[data-guide-id=\"organization-commission-preview\"]",
            "mobileTarget": "",
            "title": "启用前用预览完成最终复核",
            "text": "最后核对适用员工、触发条件、计算对象、比例和预计结果，再确认是否与其他规则重叠。完成本教程不代表规则已保存、启用或影响任何员工收入。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"organization-commission-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"organization-commission-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"organization-commission-drawer\"]",
              "close": []
            }
          }
        ]
      },
      {
        "id": "system-config",
        "group": "admin",
        "title": "管理系统配置",
        "description": "按系统默认值、问卷库、三方服务、事件、安检和高级控制理解全局配置。",
        "estimate": "约 9 分钟",
        "goals": [
          "admin"
        ],
        "permission": "admin.view",
        "permissionFallback": "[href*='config'], [data-nav='配置']",
        "steps": [
          {
            "id": "config-tabs",
            "target": "[data-guide-id=\"config-tabs\"]",
            "mobileTarget": "",
            "title": "先区分默认值、公共展示和全局控制",
            "text": "系统设置中的基础配置、供应商配置、站点配置分别对应不同的需求。正式确定修改前先确认影响对象和生效范围；教程全程不保存。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "config-base",
            "target": "[data-guide-id=\"config-basic-project\"]",
            "mobileTarget": "",
            "title": "项目首选货币和别名影响后续新建对象",
            "text": "首选货币会成为项目报价和财务核算的默认起点，别名开关影响名称展示方式。调整前应统一合同、报价和财务口径，并确认是只影响新建对象还是涉及既有数据。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "config-supplier-registration",
            "target": "[data-guide-id=\"config-supplier-access\"]",
            "mobileTarget": "",
            "title": "注册状态决定供应商能否进入业务流程",
            "text": "“直接通过”允许注册后进入系统，“审核通过”需要管理员确认，“禁止注册”关闭入口。选择前应明确准入制度、审核责任人和异常申请处理方式。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "tab": "[data-guide-id=\"config-tab-supplier\"]",
              "waitFor": "[data-guide-id=\"config-supplier-access\"]"
            }
          },
          {
            "id": "config-supplier-settlement",
            "target": "[data-guide-id=\"config-supplier-access\"]",
            "mobileTarget": "",
            "title": "最低结算金额和税率必须与财务制度一致",
            "text": "最低结算金额决定何时可以发起账单或结算，税率会影响财务计算与对账。修改前核对合同、币种和历史账单处理规则，教程不会更改数值。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "tab": "[data-guide-id=\"config-tab-supplier\"]",
              "waitFor": "[data-guide-id=\"config-supplier-access\"]"
            }
          },
          {
            "id": "config-site-identity",
            "target": "[data-guide-id=\"config-site-identity\"]",
            "mobileTarget": "",
            "title": "站点公开信息需要统一审核",
            "text": "站点名称、描述、关键词和版权信息会出现在公开页面或搜索信息中。使用正式品牌文案并确认合规、版权和多语言口径，避免把内部测试文字发布到外部。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "tab": "[data-guide-id=\"config-tab-site\"]",
              "waitFor": "[data-guide-id=\"config-site-identity\"]"
            }
          },
          {
            "id": "config-site-brand",
            "target": "[data-guide-id=\"config-site-brand\"]",
            "mobileTarget": "",
            "title": "Logo 与 favicon 是公开品牌资产",
            "text": "上传前确认文件来源、清晰度、尺寸和透明背景是否符合规范，并准备回退版本。替换品牌资源会影响用户识别，教程不会选择文件或执行上传。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "tab": "[data-guide-id=\"config-tab-site\"]",
              "waitFor": "[data-guide-id=\"config-site-brand\"]"
            }
          },
          {
            "id": "config-screen-table",
            "target": "[data-guide-id=\"config-screen-table\"]",
            "mobileTarget": "",
            "title": "先确认问卷用途、题目数和使用状态",
            "text": "前置问卷用于对于问卷正式作答前的前置筛选。编辑或删除前先确认是否已被项目或流程引用；列表中的默认、启用使用状态。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "config-screen-designer",
            "target": "[data-guide-id=\"config-screen-designer\"]",
            "mobileTarget": "",
            "title": "按“题型 → 画布 → 属性”完成问卷设计",
            "text": "先从题型工具添加问题，再在画布调整顺序，最后配置标题、选项、必填和校验属性。每次修改都应考虑已使用问卷的兼容性；教程只打开设计器。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"config-screen-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"config-screen-new-dialog\"]",
              "tab": "[data-guide-id=\"config-screen-tab-designer\"]",
              "snapshot": "[data-guide-id=\"config-screen-new-dialog\"]",
              "close": []
            }
          },
          {
            "id": "config-integrations-grid",
            "target": "[data-guide-id=\"config-integrations-catalog\"]",
            "mobileTarget": "",
            "title": "先按业务用途选择三方服务",
            "text": "短信、邮件、钉钉、微信、云服务、SSO、CDN 和 AI 等集成是按照个人不同的需求来解决不同类型的问题。按照个人的需求来进行配置。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "config-integration-credentials",
            "target": "[data-guide-id=\"config-integrations-sms\"]",
            "mobileTarget": "",
            "title": "凭据先保存并保护，再决定是否启用",
            "text": "密钥、账号、签名和服务地址属于敏感配置，只能由授权管理员维护。先核对环境和凭据，再保存、测试连接，最后决定启用；教程不会读取或修改真实凭据。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "waitFor": "[data-guide-id=\"config-integrations-sms\"]",
              "snapshot": "[data-guide-id=\"config-integrations-sms\"]"
            }
          },
          {
            "id": "config-integration-test",
            "target": "[data-guide-id=\"config-integrations-test\"]",
            "mobileTarget": "",
            "title": "连接测试不等于业务链路已经可用",
            "text": "测试通过只说明当前凭据和网络基本可达，还要验证模板、回调、额度、限流和失败告警。测试失败时先查凭据、环境、网络和服务商状态；教程不会点击测试或保存。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "waitFor": "[data-guide-id=\"config-integrations-sms\"]",
              "snapshot": "[data-guide-id=\"config-integrations-sms\"]"
            }
          },
          {
            "id": "config-events",
            "target": "[data-guide-id=\"config-events-table\"]",
            "mobileTarget": "",
            "title": "事件、接收对象和启停状态共同决定通知",
            "text": "先明确什么业务事件需要通知，再配置相关的渠道负责处理的接收信息。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "config-security-table",
            "target": "[data-guide-id=\"config-security-table\"]",
            "mobileTarget": "",
            "title": "系统安检是客户和项目规则的继承起点",
            "text": "列表中的产品、优先级、状态和规则会形成系统级安检默认配置，客户或项目可能继续继承或覆盖。先核对继承关系，再考虑启停、排序、编辑或删除。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "config-security-credentials",
            "target": ".security-product-section",
            "mobileTarget": "",
            "title": "先选安检产品，SDK 和凭据配置才会展开",
            "text": "不同安检产品需要不同的 SDK 与凭据字段。先确认产品、接入方式和运行环境，再按展开后的字段核对配置；教程只打开配置，不代替选择或保存。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"config-security-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"config-security-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"config-security-drawer\"]",
              "close": []
            }
          },
          {
            "id": "config-security-rules",
            "target": ".security-dialog-body",
            "mobileTarget": "",
            "title": "前端字段、阻止规则和优先级要一起验证",
            "text": "选择产品后，抽屉会展开前端字段、凭据和默认阻止规则；底部优先级决定多条配置的执行顺序。教程不新增规则、不启用也不保存。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": {
              "click": "[data-guide-id=\"config-security-new\"]",
              "safeAction": "open-surface",
              "waitFor": "[data-guide-id=\"config-security-drawer\"]",
              "tab": "",
              "snapshot": "[data-guide-id=\"config-security-drawer\"]",
              "close": []
            }
          },
          {
            "id": "config-advanced-scope",
            "target": "[data-guide-id=\"config-advanced-ir\"]",
            "mobileTarget": "",
            "title": "IR 与周期超限控制影响项目流量边界",
            "text": "IR 控制用于限制不符合目标条件的问卷，用于处理超出约定周期的问卷项目",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          },
          {
            "id": "config-advanced-performance",
            "target": "[data-guide-id=\"config-advanced-speed\"]",
            "mobileTarget": "",
            "title": "速度与超时控制需要结合真实链路验证",
            "text": "超时控制会限制问卷提交以及完成审核、拦截问卷在不合理的时间进行完成提交。完成本教程不代表任何高级配置已经保存或发布。",
            "interaction": "",
            "readOnly": true,
            "risk": "",
            "mobileNote": "",
            "before": null
          }
        ]
      }
    ],
    "goalTaskMap": {
      "project": [
        "interface-tour",
        "customer-management",
        "supplier-setup",
        "cooperation-resources",
        "project-create",
        "records-quality",
        "finance-overview"
      ],
      "customer": [
        "interface-tour",
        "customer-management",
        "supplier-setup",
        "cooperation-resources"
      ],
      "quality": [
        "interface-tour",
        "records-quality"
      ],
      "finance": [
        "interface-tour",
        "records-quality",
        "finance-overview"
      ],
      "admin": [
        "interface-tour",
        "organization-permissions",
        "system-config"
      ],
      "station": [
        "interface-tour",
        "station-overview",
        "station-members",
        "station-settings"
      ]
    },
    "experienceStepIds": {
      "new": {
        "interface-tour": [
          "top-nav",
          "side-nav",
          "global-search",
          "personal-menu",
          "quick-actions"
        ],
        "customer-management": [
          "customer-filters",
          "customer-table",
          "customer-new",
          "customer-identity",
          "customer-settlement",
          "customer-assignment",
          "customer-invoice"
        ],
        "supplier-setup": [
          "supplier-table",
          "supplier-new",
          "supplier-identity",
          "supplier-settlement",
          "supplier-control",
          "supplier-regions",
          "supplier-finance-account",
          "supplier-callback"
        ],
        "cooperation-resources": [
          "cooperation-overview",
          "cooperation-profile",
          "cooperation-supplier-market",
          "cooperation-supplier-detail",
          "cooperation-customer-market",
          "cooperation-customer-detail",
          "cooperation-applications",
          "cooperation-partners",
          "cooperation-points",
          "cooperation-bills"
        ],
        "project-create": [
          "project-filters",
          "project-table",
          "project-new",
          "project-drawer",
          "project-identity",
          "project-commercial",
          "project-metrics",
          "project-quota-device",
          "project-risk-tab",
          "project-risk-security"
        ],
        "records-quality": [
          "record-filter",
          "record-expand",
          "record-table",
          "record-export"
        ],
        "finance-overview": [
          "finance-log-filters",
          "finance-log-table",
          "finance-log-safety",
          "finance-bill-table",
          "finance-bill-risk",
          "finance-invoice-table",
          "finance-invoice-risk"
        ],
        "station-overview": [
          "station-nav",
          "station-kpis",
          "station-wallets",
          "station-analysis"
        ],
        "station-members": [
          "station-member-filters",
          "station-group-table",
          "station-level-table",
          "station-member-table",
          "station-member-new",
          "station-member-drawer"
        ],
        "station-settings": [
          "station-settings-tabs",
          "station-settings-access",
          "station-settings-member",
          "station-settings-protocol",
          "station-settings-actions",
          "station-schedule-table",
          "station-schedule-new"
        ],
        "organization-permissions": [
          "org-department-filters",
          "org-department-table",
          "org-department-drawer",
          "org-department-permission",
          "org-department-manager",
          "org-role-table",
          "org-role-dialog",
          "org-role-menu",
          "org-role-permissions",
          "org-role-diagnostics",
          "org-employee-filters",
          "org-employee-table",
          "org-employee-account",
          "org-employee-assignment",
          "org-commission-table",
          "org-commission-employees",
          "org-commission-conditions",
          "org-commission-preview"
        ],
        "system-config": [
          "config-tabs",
          "config-base",
          "config-supplier-registration",
          "config-supplier-settlement",
          "config-site-identity",
          "config-site-brand",
          "config-screen-table",
          "config-screen-designer",
          "config-integrations-grid",
          "config-integration-credentials",
          "config-integration-test",
          "config-events",
          "config-security-table",
          "config-security-credentials",
          "config-security-rules",
          "config-advanced-scope",
          "config-advanced-performance"
        ]
      },
      "similar": {
        "interface-tour": [
          "top-nav",
          "global-search",
          "personal-menu",
          "quick-actions"
        ],
        "customer-management": [
          "customer-table",
          "customer-new",
          "customer-identity",
          "customer-settlement",
          "customer-invoice"
        ],
        "supplier-setup": [
          "supplier-table",
          "supplier-new",
          "supplier-settlement",
          "supplier-control",
          "supplier-finance-account",
          "supplier-callback"
        ],
        "cooperation-resources": [
          "cooperation-overview",
          "cooperation-profile",
          "cooperation-supplier-detail",
          "cooperation-customer-detail",
          "cooperation-applications",
          "cooperation-partners",
          "cooperation-bills"
        ],
        "project-create": [
          "project-table",
          "project-new",
          "project-drawer",
          "project-commercial",
          "project-metrics",
          "project-quota-device",
          "project-risk-security"
        ],
        "records-quality": [
          "record-filter",
          "record-table",
          "record-export"
        ],
        "finance-overview": [
          "finance-log-safety",
          "finance-bill-table",
          "finance-bill-risk",
          "finance-invoice-table",
          "finance-invoice-risk"
        ],
        "station-overview": [
          "station-nav",
          "station-wallets",
          "station-analysis"
        ],
        "station-members": [
          "station-group-table",
          "station-level-table",
          "station-member-table",
          "station-member-new"
        ],
        "station-settings": [
          "station-settings-access",
          "station-settings-member",
          "station-settings-protocol",
          "station-schedule-table",
          "station-schedule-new"
        ],
        "organization-permissions": [
          "org-department-table",
          "org-department-permission",
          "org-department-manager",
          "org-role-table",
          "org-role-menu",
          "org-role-permissions",
          "org-role-diagnostics",
          "org-employee-table",
          "org-employee-assignment",
          "org-commission-table",
          "org-commission-employees",
          "org-commission-conditions",
          "org-commission-preview"
        ],
        "system-config": [
          "config-base",
          "config-supplier-registration",
          "config-supplier-settlement",
          "config-site-identity",
          "config-screen-table",
          "config-integrations-grid",
          "config-integration-credentials",
          "config-integration-test",
          "config-events",
          "config-security-table",
          "config-security-rules",
          "config-advanced-scope",
          "config-advanced-performance"
        ]
      },
      "expert": {
        "interface-tour": [
          "top-nav",
          "global-search",
          "personal-menu"
        ],
        "customer-management": [
          "customer-table",
          "customer-settlement",
          "customer-callback-s2s"
        ],
        "supplier-setup": [
          "supplier-table",
          "supplier-control",
          "supplier-finance-account"
        ],
        "cooperation-resources": [
          "cooperation-overview",
          "cooperation-supplier-detail",
          "cooperation-customer-detail",
          "cooperation-applications",
          "cooperation-bills"
        ],
        "project-create": [
          "project-table",
          "project-metrics",
          "project-quota-device",
          "project-risk-security"
        ],
        "records-quality": [
          "record-filter",
          "record-table"
        ],
        "finance-overview": [
          "finance-log-safety",
          "finance-bill-risk",
          "finance-invoice-risk"
        ],
        "station-overview": [
          "station-nav",
          "station-wallets"
        ],
        "station-members": [
          "station-group-table",
          "station-level-table",
          "station-member-table"
        ],
        "station-settings": [
          "station-settings-access",
          "station-settings-member",
          "station-schedule-new"
        ],
        "organization-permissions": [
          "org-department-permission",
          "org-department-manager",
          "org-role-menu",
          "org-role-permissions",
          "org-role-diagnostics",
          "org-employee-table",
          "org-employee-assignment",
          "org-commission-preview"
        ],
        "system-config": [
          "config-base",
          "config-supplier-registration",
          "config-integration-credentials",
          "config-integration-test",
          "config-events",
          "config-security-table",
          "config-security-rules",
          "config-advanced-performance"
        ]
      }
    }
  }
} as const
